{
  "DASHBOARD_ACTIONS": {
    "EMPTY": "Aucune action à réaliser pour le moment.",
    "TITLE": "Vos actions à réaliser",
    "DAY_WITH_COUNT": "Depuis {count} jour",
    "DAYS_WITH_COUNT": "Depuis {count} jours"
  },
  "repairFileWorkflow": {
    "declaration": {
      "option": "Décision déclarée (facultatif)",
      "recipient": "Destinataire de l’envoi déclaré",
      "optionalDecision": "Sans décision renseignée, l’étape sera enregistrée sans preuve de transmission. La date sélectionnée est la date déclarée."
    },
    "title": "Vos prochaines actions",
    "nextAction": "VOTRE PROCHAINE ACTION : {action}",
    "pastAction": "ACTION À CETTE ÉTAPE : {action}",
    "noValue": "Non renseigné",
    "remindersActive": "Relances automatiques activées.",
    "options": {
      "OPTION_1": "Forfait de réparation",
      "OPTION_2": "Diagnostic et devis",
      "OPTION_3": "Recyclage",
      "CREDIT_OR_REFUND": "Avoir / remboursement",
      "PRODUCT_REPLACEMENT": "Échange par un produit neuf",
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Demande de retour du produit pour diagnostic",
      "PRODUCT_REPAIR_WITH_GUARANTEE": "Réparation sous garantie",
      "TECHNICIAN_ON_SITE_INTERVENTION": "Intervention d’un technicien sur site",
      "REJECT_PROSPECT": "Refus de prise en charge",
      "OTHER": "Autre",
      "DIAGNOSIS": "Diagnostic et devis",
      "ON_SITE": "Intervention d’un technicien sur site"
    },
    "events": {
      "PRELIMINARY_INFORMATION_RECEIVED": "INFORMATIONS COMPLÉMENTAIRES SUR LA RÉPONSE RÉPARATEUR. N° de demande : {request_number}. Commentaire : {comment}",
      "FILE_CLOSED_DECLARED": "12. DOSSIER CLÔTURÉ MANUELLEMENT par {actor} le {date}.",
      "CUSTOMER_AVAILABILITY_DECLARED": "11a. INFORMATION DU CLIENT DÉCLARÉE par {actor}. Attente récupération / collecte.",
      "CUSTOMER_DECISION_FORWARDED_TO_STORE": "7. DÉCISION TRANSMISE PAR LE SYSTÈME AU MAGASIN à {recipient} : {option}. L’envoi au réparateur reste à déclarer.",
      "BREAKDOWN_REPORTED": "A décrit le problème suivant : {description}.",
      "FILE_CREATION_STARTED": "1. CRÉATION DOSSIER EN COURS.",
      "PACKAGE_PROPOSAL_SENT": "PROPOSITION DE FORFAIT ENVOYÉE AU CLIENT. En attente du retour client depuis le {date}.",
      "PACKAGE_DECISION_RECEIVED": "DÉCISION DU CLIENT (via email) : {option}.",
      "PRELIMINARY_REQUEST_SENT": "Demande préalable envoyée à {recipient} avec les commentaires suivants, dans l’attente de son retour : {description}.",
      "PRELIMINARY_RESPONSE_RECEIVED": "DÉCISION RÉPARATEUR (via email) : {option}. Demande préalable : retour du fabricant. N° de demande : {request_number}.",
      "PRELIMINARY_RESPONSE_DECLARED": "DÉCISION RÉPARATEUR (déclarée par l’utilisateur) : {option}. Demande préalable : retour du fabricant. N° de demande : {request_number}.",
      "TRANSPORT_LABELS_REQUESTED": "Votre demande de transport a été envoyée à {recipient} le {date}. Vous allez recevoir rapidement les étiquettes de transport.",
      "OUTBOUND_TRANSPORT_STARTED": "2. TRANSPORT ALLER DÉCLENCHÉ depuis le {date}.",
      "REPAIRER_RECEIPT_RECORDED": "3. RÉCEPTION CHEZ LE RÉPARATEUR depuis le {date}.",
      "REPAIRER_ESTIMATE_REPORTED_SENT": "4. DEVIS ENVOYÉ PAR LE RÉPARATEUR à l’adresse email {recipient} depuis le {date}.",
      "REPAIRER_ESTIMATE_INTEGRATED": "5. DEVIS FABRICANT INTÉGRÉ AU DOSSIER.",
      "CUSTOMER_ESTIMATE_SENT": "6. DEVIS ENVOYÉ AU CLIENT. En attente de sa décision.",
      "CUSTOMER_ESTIMATE_SEND_DECLARED": "6. ENVOI DU DEVIS AU CLIENT DÉCLARÉ HORS PLATEFORME. En attente de sa décision.",
      "CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. DÉCISION CLIENT ENVOYÉE AU RÉPARATEUR PAR LE SYSTÈME : {option}. Traitement en cours depuis le {date}.",
      "CUSTOMER_DECISION_SEND_DECLARED": "7. ENVOI DE LA DÉCISION AU RÉPARATEUR DÉCLARÉ PAR LE MAGASIN : {option}. Sans trace de validation par email du client. Traitement en cours depuis le {date}.",
      "CUSTOMER_DECISION_TRANSMISSION_UNVERIFIED": "7. TRANSMISSION DE LA DÉCISION DÉCLARÉE. Étape sélectionnée sans envoi par le système.",
      "REPAIR_STARTED": "8. EN RÉPARATION depuis le {date}.",
      "REPAIR_PARTS_ORDERED": "8. EN RÉPARATION — PIÈCES COMMANDÉES depuis le {date}.",
      "REPAIRER_RETURN_STARTED": "9. EXPÉDITION PAR LE RÉPARATEUR. Transport retour enclenché depuis le {date}.",
      "NO_RETURN_TREATMENT_FINALIZED": "9. GESTION FINALISÉE PAR LE RÉPARATEUR : {option}.",
      "DEPOT_RECEIPT_RECORDED": "10. RÉCEPTION EN MAGASIN.",
      "CUSTOMER_AVAILABILITY_NOTIFIED": "11a. CLIENT INFORMÉ. Attente récupération / collecte.",
      "CUSTOMER_RETURN_DISPATCHED": "11b. TRANSPORT RETOUR CHEZ LE CLIENT DÉCLENCHÉ.",
      "FILE_CLOSED_WITH_RETURN": "12. REMISE AU CLIENT DÉCLARÉE — DOSSIER CLÔTURÉ : {option}.",
      "FILE_CLOSED_WITHOUT_RETURN": "12. DOSSIER CLÔTURÉ : {option}. Sans restitution.",
      "BILLING_STAGE_ENTERED": "13. FACTURATION.",
      "FILE_FINISHED": "14. DOSSIER TERMINÉ.",
      "PACKAGE_PROPOSAL_QUEUED": "Proposition de forfait préparée. Envoi au client en attente.",
      "PRELIMINARY_REQUEST_QUEUED": "Demande préalable préparée. Envoi au réparateur en attente.",
      "CUSTOMER_ESTIMATE_QUEUED": "Devis préparé. Envoi au client en attente.",
      "CUSTOMER_DECISION_QUEUED": "Décision enregistrée : {option}. Transmission par la plateforme en attente.",
      "CUSTOMER_RETURN_DELIVERED": "Le transporteur signale la livraison au client le {date}. La clôture reste manuelle.",
      "CUSTOMER_RECEIPT_SMS_SENT": "SMS envoyé au {phone} pour confirmation de réception du produit, le {date}.",
      "CUSTOMER_RECEIPT_CONFIRMED": "Le client confirme avoir réceptionné le produit le {date}. Photo ci-jointe : Photo client du produit retourné. Commentaire du client : {comment}",
      "FILE_ABANDONED": "Dossier abandonné par le client.",
      "FILE_DELETED": "Dossier supprimé."
    },
    "actions": {
      "COMPLETE_REPAIR_FILE": "Compléter les informations nécessaires avant envoi.",
      "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "Cliquer sur \"Nouvelle action\" et continuer le process pour finaliser le transport.",
      "CONTACT_SUPPORT_IF_LABELS_MISSING": "Sans nouvelle de sa part (24h), merci de contacter BOOMERANG via le chat (bulle verte) en indiquant l'option \"Je n'ai pas recu mon étiquette\"",
      "INTEGRATE_AND_SEND_CUSTOMER_ESTIMATE": "Cliquer sur \"nouvelle action\" pour intégrer le devis et qu'il soit envoyé automatiquement au client.",
      "ENTER_ERP_BILLING": "saisir la facturation dans l'ERP",
      "DESCRIBE_CUSTOMER_DECISION": "Merci de comuniquer la décision dans les commentaires, si vous voulez un suivi.",
      "PROVIDE_DELIVERY_NOTE_AND_WARRANTY": "pour les machines réparées, faire signer le Bon de livraison et remettre l'extension de garantie au client"
    }
  },
  "CLIENT_RETURN_TRANSPORT": {
    "LABEL": "Étiquette de transport retour (PDF)",
    "UPLOAD_LABEL": "Enregistrer l’étiquette retour",
    "TITLE": "Préparer le retour au client",
    "SUBTITLE": "Vérifiez les coordonnées du destinataire, choisissez le transport et préparez les documents de retour.",
    "STEP_1": "1. Informations d’adresse",
    "STEP_2": "2. Choix du transport",
    "STEP_3": "Expédition",
    "STEP_4": "Dernières étapes du retour client",
    "BOOMERANG": "Envoi par transporteur de BOOMERANG",
    "OWN_MEANS": "Envoi par vos propres moyens",
    "BACK": "Retour au dossier",
    "DEPARTURE": "Départ — magasin",
    "RECIPIENT": "Destinataire — client",
    "CARRIER": "Transporteur",
    "SERVICE": "Service de transport",
    "SPECIFIC_INSTRUCTIONS": "Organisez le transport avec l’équipe BOOMERANG, puis renseignez ici le transporteur et le numéro de suivi du retour client.",
    "DOCUMENTS": "Documents retour pour le client",
    "STEP_11A": "Client informé dispo en magasin",
    "STEP_11B": "Transport retour chez le client",
    "CLIENT_RETURN_ADDRESS": "RETOUR - ADRESSE CLIENT"
  },
  "ATTACHMENT_UPLOAD": {
    "FROM_COMPUTER": "Depuis l'ordinateur",
    "VIA_MOBILE": "Via mobile",
    "COMPUTER": "Via votre ordinateur",
    "MOBILE": "Via votre téléphone ou pad",
    "PHOTO_TITLE": "Ajouter des photos",
    "DOCUMENT_TITLE": "Ajouter des documents",
    "ANY_FORMAT": "Tous les formats de documents",
    "IMAGES": "JPG, PNG",
    "REMOVE_BEFORE_UPLOAD": "Un justificatif est déjà enregistré. Supprimez-le avant d’ajouter son remplacement.",
    "SESSION_INVALID": "Ce QR code a expiré ou n’est plus disponible. Générez un nouveau code pour continuer.",
    "PARTIAL": "Certains fichiers ont été enregistrés. Les fichiers en échec restent sélectionnés pour réessayer.",
    "REFRESH_FAILED": "L’ajout a été enregistré, mais la liste actualisée n’a pas pu être chargée. Actualisez la liste avant d’ajouter d’autres fichiers.",
    "LOAD_FAILED": "Les pièces jointes actuelles n’ont pas pu être chargées. Réessayez avant l’ajout.",
    "CAPACITY_REACHED": "Le nombre maximal de fichiers enregistrés est atteint. Supprimez un fichier avant d’en ajouter un autre.",
    "CAPACITY_EXCEEDED": "La sélection dépasse le nombre de fichiers encore autorisé.",
    "CAPACITY": "{count} documents enregistrés sur {max} · {remaining} disponibles",
    "FILE_TOO_LARGE": "Un fichier sélectionné dépasse la taille autorisée.",
    "NAME_TOO_LONG": "Le nom du fichier doit contenir au maximum {max} caractères."
  },
  "PUBLIC_DECISION": {
    "UPDATED_SELECTION": "La proposition a été modifiée. Vérifiez les nouvelles informations avant de confirmer à nouveau.",
    "TITLE": "Confirmer votre choix",
    "SUBTITLE": "Vérifiez la proposition ci-dessous avant de confirmer votre décision.",
    "REFERENCE": "Dossier {reference}",
    "TOTAL_COST": "Coût total",
    "CONFIRM": "Confirmer ce choix",
    "BRAND_LOGO": "Logo du réseau ou du magasin",
    "RECORDED_TITLE": "Votre choix est enregistré",
    "COMPLETED_TITLE": "Informations enregistrées",
    "COMPLETED_MESSAGE": "Vos informations sont enregistrées et leur transmission a été prise en compte. Vous pouvez fermer cette page.",
    "FOLLOWUP_UNAVAILABLE": "Votre décision reste enregistrée. L’accès au formulaire complémentaire a expiré ou a été révoqué. Contactez le magasin si vous devez ajouter des informations.",
    "OPTIONAL_ATTACHMENT": "Pièce jointe (facultative)",
    "PACKAGE_OPTIONS": {
      "OPTION_1": "Accepter le forfait de réparation",
      "OPTION_2": "Demander un diagnostic et un devis au réparateur",
      "OPTION_3": "Ne pas faire réparer le produit"
    },
    "PURCHASE": {
      "TITLE": "Bon de commande",
      "OFFER": "Vous pouvez transmettre un bon de commande ou une référence au magasin.",
      "ADD": "Ajouter un bon de commande",
      "HINT": "Le numéro, la référence et le document sont facultatifs. Vous pouvez terminer sans ajouter d’informations.",
      "ORDER_NUMBER": "Numéro de commande (facultatif)",
      "CALLBACK_REF": "Référence à rappeler (facultative)",
      "COMPLETE_WITHOUT_DETAILS": "Terminer sans ajout"
    },
    "MANUFACTURER": {
      "TITLE": "Informations de prise en charge",
      "HINT": "Ajoutez le numéro de prise en charge et, si nécessaire, les instructions de retour et un document.",
      "SUPPORT_NUMBER": "Numéro de prise en charge",
      "RETURN_ADDRESS": "Adresse ou instructions de retour (facultatives)",
      "RECIPIENTS": "Destinataires",
      "STORE_RECIPIENT": "Le magasin est toujours informé. Sélectionnez les destinataires supplémentaires.",
      "SEND_TO": "Informer {email}",
      "OTHER_RECIPIENTS": "Autres destinataires (facultatifs)",
      "EMAIL_PLACEHOLDER": "adresse1{'@'}exemple.fr; adresse2{'@'}exemple.fr"
    }
  },
  "PUBLIC_UPLOAD": {
    "CAPACITY_EXCEEDED": "La sélection dépasse le nombre de photos encore autorisé.",
    "PHOTOS": {
      "TITLE": "Ajouter les photos du produit",
      "SUBTITLE": "Ajoutez une ou plusieurs photos du produit depuis votre mobile.",
      "DROPZONE": "Déposez les photos",
      "FORMATS": "JPG, JPEG, PNG",
      "REMOVE": "Supprimer la photo",
      "SUBMIT": "Envoyer les photos",
      "CAPACITY": "{count} / {max} photos enregistrées · {remaining} emplacement(s) disponible(s)",
      "PARTIAL": "Certaines photos sont enregistrées. Réessayez les photos restantes ou retournez sur l’ordinateur pour confirmer celles déjà envoyées.",
      "FAILED_FILES": "Photos non envoyées : {names}",
      "FULL": "Le nombre maximal de photos est atteint. Retournez sur l’ordinateur pour vérifier le dossier.",
      "SUCCESS_TITLE": "Photos envoyées",
      "SUCCESS_MESSAGE": "Vos photos sont enregistrées. Retournez sur l’ordinateur pour confirmer l’ajout. Pour envoyer d’autres photos, générez un nouveau QR code."
    },
    "PROOF": {
      "TITLE": "Ajouter le justificatif",
      "SUBTITLE": "Ajoutez le justificatif depuis votre mobile."
    },
    "ATTACHMENT": {
      "TITLE": "Ajouter une pièce jointe",
      "SUBTITLE": "Ajoutez le document depuis votre mobile.",
      "NAME": "Nom du fichier"
    },
    "DOCUMENT": {
      "DROPZONE": "Déposez le document",
      "FORMATS": "PDF, JPG, PNG",
      "REMOVE": "Supprimer le document",
      "HINT": "Après l’envoi, retournez sur l’ordinateur pour confirmer.",
      "SUBMIT": "Envoyer le document",
      "SUCCESS_TITLE": "Document envoyé",
      "SUCCESS_MESSAGE": "Vous pouvez retourner sur l’ordinateur et confirmer l’envoi."
    },
    "TAKE_PHOTO": "Prendre une photo",
    "MAX_SIZE": "Taille maximale {size} {unit}",
    "TOO_LARGE": "Ce fichier dépasse la taille maximale autorisée.",
    "REPLACE_PHOTO": "Remplacer la photo",
    "BYTE": "o",
    "KILOBYTE": "Ko",
    "MEGABYTE": "Mo"
  },
  "LOGIN_PAGE": {
    "TITLE": {
      "HEADER": "Connectez-vous",
      "EMAIL": "Email",
      "PASSWORD": "Mot de passe",
      "COLLABORATOR": "Collaborateur",
      "FIRSTNAME": "Prénom",
      "LASTNAME": "Nom",
      "TWO_FACTOR": "Vérification 2FA"
    },
    "BUTTON": {
      "SUBMIT": "Me connecter",
      "SUBMIT_COLLABORATOR": "S’identifier",
      "ADD_NEW_COLLABORATOR": "Ajouter un collaborateur",
      "ADD_COLLABORATOR": "Ajouter un collaborateur",
      "HELP": "Besoin d'aide ?",
      "ADD_ACCOUNT": "Inscrivez-vous",
      "REGISTRATION_PROMPT": "Pas encore de compte ?",
      "FORGOT_PASSWORD": "Mot de passe oublié ?",
      "RESET_PASSWORD": "Réinitialiser",
      "VERIFY_TWO_FACTOR": "Vérifier le code",
      "RESEND_TWO_FACTOR": "Renvoyer le code"
    },
    "INPUT": {
      "SELECT_COLLABORATOR": "Sélectionnez un collaborateur",
      "ADD_COLLABORATOR": "Crée le collaborateur",
      "EMAIL_PLACEHOLDER": "Ex : contact{'@'}boomerang.com",
      "PASSWORD_PLACEHOLDER": "Saisir votre mot de passe",
      "TWO_FACTOR_CODE": "Code de vérification reçu par email"
    },
    "MESSAGE": {
      "SUCCESS": "Connexion réussie",
      "ERROR": "Identifiant incorrect",
      "NO_COLLABORATOR": "Aucun collaborateur n'est disponible pour ce compte",
      "TWO_FACTOR_SENT": "Un code de vérification vous a été envoyé par email"
    }
  },
  "LOGIN_ADD_COLLABORATOR": {
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le collaborateur"
    }
  },
  "LOGIN_FORGOT_PASSWORD": {
    "TITLE": {
      "HEADER": "Mot de passe oublié",
      "EMAIL": "Email"
    },
    "BUTTON": {
      "SUBMIT": "Envoyer"
    },
    "MESSAGE": {
      "SUCCESS": "Un email de réinitialisation vous a été envoyé",
      "ERROR": {
        "CAPTCHA": "Captcha invalide"
      }
    }
  },
  "LOGIN_REGISTER": {
    "TITLE": {
      "HEADER": "Formulaire d'inscription",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "EMAIL": "Email",
      "PHONE_NUMBER": {
        "TITLE": "Numéro de téléphone",
        "LABEL": "Numéro",
        "COUNTRY": "Pays"
      },
      "COMPANY_NAME": "Nom de l'entreprise",
      "WHICH_MARKET": "Quel est le magasin concerné ?",
      "JOB_DETAILS": "Quelle est la description de votre poste ?",
      "GEOGRAPHICAL": "Zone géographique couverte",
      "USER_JOB": "Fonction dans l'entreprise",
      "MANAGER_EMAIL": "Adresse e-mail du responsable",
      "CGU": "CGU",
      "QUESTION_CGU": "J'ai pris connaissance des",
      "CHIPS_MESSAGE": "autres",
      "CHIP_MESSAGE": "autre"
    },
    "BUTTON": {
      "NEXT": "Suivant",
      "SUBMIT": "Envoyer ma demande"
    },
    "MESSAGE": {
      "SUCCESS": "Demande d'inscription bien transmise",
      "NO_DATA": "Aucune donnée",
      "ERROR": {
        "CAPTCHA": "Captcha invalide",
        "TOS": " Accepter les CGU pour continuer",
        "502": "Impossible de communiquer avec le serveur",
        "JOB_TYPE": "Le type de job spécifié est invalide"
      }
    },
    "SELECT_FIELD_TEXT": {
      "ROLE": "Sélectionnez la fonction d'entreprise",
      "GEOGRAPHICAL_ZONE": "Sélectionnez une zone géographique"
    }
  },
  "RESET_PASSWORD": {
    "TITLE": "Réinitialisez votre mot de passe",
    "PASSWORD": "Mot de passe",
    "CONFIRM_PASSWORD": "Confirmation du mot de passe",
    "PASSWORD_PLACEHOLDER": "Saisir votre mot de passe",
    "CONFIRM_PASSWORD_PLACEHOLDER": "Confirmer votre mot de passe",
    "SUCCESS": "Mot de passe modifié avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 60 minutes. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Modifier"
    }
  },
  "INIT_PASSWORD": {
    "TITLE": "Renseignez votre mot de passe",
    "PASSWORD": "Nouveau mot de passe",
    "CONFIRM_PASSWORD": "Confirmez votre mot de passe",
    "PASSWORD_PLACEHOLDER": "Saisir votre mot de passe",
    "CONFIRM_PASSWORD_PLACEHOLDER": "Confirmer votre mot de passe",
    "SUCCESS": "Mot de passe créé avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 7 jours. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Modifier"
    }
  },
  "PROFILE_PAGE": {
    "TITLE": {
      "HEADER": "Édition du profil",
      "SUBTITLE": "Gérez vos informations personnelles, votre mot de passe et vos collaborateurs."
    },
    "TABS": {
      "PERSONAL_INFORMATION": "Informations personnelles",
      "PASSWORD": "Mot de passe",
      "COLLABORATORS": "Collaborateurs"
    },
    "SEARCH_COLLABORATORS": "Rechercher un collaborateur",
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL_LOGIN": "Email de connexion",
      "CONNECTION_INFO": "Information connexion",
      "LABEL_CURRENT_PASSWORD": "Mot de passe actuel",
      "LABEL_NEW_PASSWORD": "Nouveau mot de passe",
      "LABEL_CONFIRM_PASSWORD": "Confirmer le mot de passe"
    },
    "PLACEHOLDERS": {
      "PHONE": "Téléphone",
      "CURRENT_PASSWORD": "Mot de passe actuel",
      "NEW_PASSWORD": "Nouveau mot de passe",
      "CONFIRM_PASSWORD": "Confirmer le mot de passe"
    },
    "TABLE": {
      "COLLABORATORS": "Collaborateurs",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "STATUS": "Statut",
      "LOADING_COLLABORATOR": "Chargement des collaborateurs...",
      "NO_COLLABORATOR": "Aucun collaborateur",
      "NO_JOB_DESCRIPTION": "Non renseigné"
    },
    "STATUS": {
      "active": "Actif",
      "inactive": "Inactif",
      "deleted": "Supprimé",
      "pending": "En attente"
    },
    "DIALOGUE": {
      "TITLE": "Supprimer un collaborateur",
      "MESSAGE": "Voulez-vous vraiment supprimer {collaborator}?",
      "WARNING": "Cette action est irréversible."
    },
    "BUTTON": {
      "ADD_COLLABORATOR": "Créer un collaborateur",
      "UPDATE_COLLABORATOR": "Modifier le collaborateur",
      "VALIDATE": "Valider",
      "VALIDATE_PASSWORD": "Valider le mot de passe"
    },
    "MESSAGE": {
      "SUCCESS": "Profil mis à jour",
      "SUCCESS_ACTIVE": "Collaborateur activé",
      "SUCCESS_INACTIVE": "Collaborateur supprimé",
      "ERROR": "Impossible de modifier le profil",
      "ERROR_PASSWORD": "Mot de passe incorrect"
    }
  },
  "COLLABORATOR_PAGE": {
    "TABLE": {
      "FIRSTNAME": "Prénom",
      "LASTNAME": "Nom",
      "ROLE": "Fonction",
      "STATUS": "Statut",
      "LOADING_USER": "Chargement des utilisateurs...",
      "NO_USER": "Aucun utilisateur"
    },
    "BUTTON": {
      "DETAIL": "Détails",
      "UPDATE": "Mettre à jour"
    }
  },
  "CREATE_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Création d'un collaborateur",
      "SUBTITLE": "Formulaire de création d'un collaborateur"
    },
    "PERSONAL_INFO": "Informations personnelles",
    "FIRSTNAME": "Prénom",
    "LASTNAME": "Nom",
    "JOB_DESCRIPTION": "Métier",
    "BUTTON": {
      "CREATE": "Ajouter"
    },
    "ERROR": {
      "USER_EXIST": "Utilisateur déjà existant"
    }
  },
  "CREATE_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un collaborateur",
      "SUBTITLE": "Formulaire d'ajout d'un collaborateur"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_JOB_DESCRIPTION": "Métier"
    },
    "BUTTON": { "VALIDATE": "Valider l'ajout d'un collaborateur" },
    "MESSAGE": { "SUCCESS": "Le collaborateur a été ajouté avec succès" },
    "PLACEHOLDER": {
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie",
      "JOB_DESCRIPTION": "Décrire les informations utiles"
    }
  },
  "EDIT_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un collaborateur",
      "SUBTITLE": "Formulaire d'édition d'un collaborateur"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_JOB_DESCRIPTION": "Métier",
      "LABEL_STATUS": "Statut"
    },
    "BUTTON": { "VALIDATE": "Valider l'édition d'un collaborateur" },
    "MESSAGE": { "SUCCESS": "Le collaborateur a été modifié avec succès" },
    "PLACEHOLDER": {
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie",
      "JOB_DESCRIPTION": "Décrire les informations utiles"
    }
  },
  "EDIT_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Édition d'un collaborateur",
      "SUBTITLE": "Modifiez les informations du collaborateur."
    },
    "PERSONAL_INFO": "Informations personnelles",
    "FIRSTNAME": "Prénom",
    "LASTNAME": "Nom",
    "JOB_DESCRIPTION": "Métier",
    "BUTTON": {
      "UPDATE": "Valider"
    },
    "ERROR": {
      "NO_COLLABORATOR": "Le collaborator n'existe pas",
      "USER_EXIST": "Utilisateur déjà existant"
    },
    "SUCCESS": "Collaborateur mis à jour"
  },
  "ERROR_INPUT": {
    "SMS_MOBILE_NUMBER": "Ce N° de téléphone n'est pas valable pour l'envoi du SMS prevenant votre client. Rentrez à la place un numero commencant par 06 ou 07 ou Selectionnez l'option \"APPEL\"",
    "EMAIL": {
      "EMPTY": "L'email ne peut pas être vide",
      "INVALID": "Entrez un email valide",
      "MAX_LENGTH": "Le nombre de caractères maximum a été dépassé"
    },
    "MAX_LENGTH": "Le nombre de caractères maximum a été dépassé",
    "MIN_LENGTH": "Le champ doit contenir au moins {min} caractères",
    "PHONE": "Le champ du téléphone n'est pas dans le bon format",
    "PHONE_SMS_HINT": "Numero invalide pour l'envoi des SMS ! Mettre un 06 ou 07...",
    "PHONE_PREFIX": "Le numéro de téléphone doit commencer par 06 ou 07",
    "PASSWORD": {
      "EMPTY": "Le mot de passe ne peut pas être vide",
      "ERROR_LENGTH": "Longueur minimum 12 caractères",
      "ERROR_UPPERCASE": "Doit contenir au moins une lettre majuscule",
      "ERROR_LOWERCASE": "Doit contenir au moins une lettre minuscule",
      "ERROR_DIGIT": "Doit contenir au moins un chiffre",
      "ERROR_SPECIAL_CHAR": "Doit contenir au moins un des caractères spéciaux suivant : {'!@#$%^&*(),.?\":{}|<>'}",
      "DIFFERENT_PASSWORD": "Les mots de passe doivent être identiques"
    },
    "PHONE_NUMBER": "Le champ n'est pas un numéro de téléphone valide (exemple : 01 23 45 67 89).",
    "WORKSITE_CODE": "Le champ doit contenir uniquement des lettres majuscules et/ou des chiffres.",
    "EMPTY": "Le champ ne peut pas être vide",
    "POSITIVE_VALUE": "Valeur positive ou égal à 0",
    "MARGIN_MAX_VALUE": "La valeur doit être inférieure ou égale à 60",
    "NOT_A_NUMBER": "Le champ doit être un nombre.",
    "MAX_FILES": "Vous ne pouvez télécharger que {max} fichiers."
  },
  "SELECT": {
    "SELECT_REGISTER": "Sélectionnez une fonction d'entreprise",
    "SELECT_USER": "Sélectionnez votre identifiant",
    "USER_ROLE": {
      "COUNTER_SALES_REPRESENTATIVE": "Vendeur comptoir",
      "TELEPHONE_SALES_REPRESENTATIVE": "Vendeur téléphonique",
      "FIELD_SALES_REPRESENTATIVE": "Vendeur itinérant",
      "NATIONAL_AFTER-SALES": "Vendeur SAV national",
      "STORE_MANAGER": "Responsable magasin",
      "GEOGRAPHICAL_MANAGER": "Manager géographique",
      "MARKET/PRODUCT_CELL": "Cellule marché/produits",
      "STORE_CELL": "Cellule magasins",
      "PURCHASING/LOGISTICS/CSRD": "Direction achat/logistique/RSE",
      "DISTRIBUTOR_DATABASE_MANAGER": "Gestionnaire BDD distributeur",
      "DISTRIBUTOR_FINANCE_TEAM": "Équipe finance distributeur"
    }
  },
  "ERROR_STATUS_CODE_MESSAGE": {
    "200": "Requête réussie",
    "400": "Requête incorrecte",
    "401": "Votre session a expirée, veuillez vous identifier à nouveau",
    "403": "Action non autorisé",
    "404": "Page non trouvée",
    "405": "Requête inconnue",
    "413": "Fichier trop volumineux",
    "500": "Erreur interne du serveur",
    "502": "Erreur de réseau",
    "504": "Temps d'attente dépassé",
    "524": "Le traitement a pris trop de temps et a été interrompu. Vérifiez si vos données ont bien été importées.",
    "NOT_REDIRECT": "Redirection impossible",
    "UNKNOWN": "Une erreur inconnue est survenue"
  },
  "ERROR": {
    "PACKAGE_CODE_ADJUSTMENT_DISABLED_ERROR": "La modification du forfait par code est désactivée pour ce magasin. Rechargez la tarification.",
    "SMS_NOTIFICATION_FAILED_ERROR": "Le SMS n'a pas pu être envoyé. Veuillez réessayer.",
    "SMS_SERVICE_UNAVAILABLE_ERROR": "Les notifications SMS sont indisponibles. Veuillez réessayer plus tard ou choisir un autre moyen de notification.",
    "ACCOUNT_NOT_FOUND_ERROR": "Compte introuvable.",
    "ADDITIONAL_REPAIR_COST_ERROR": "Surcoûts de réparation invalides.",
    "ALTERNATIVE_REPAIR_CENTER_NOT_FOUND_ERROR": "Centre de réparation alternatif introuvable.",
    "BILLING_NOT_FOUND_ERROR": "Facturation introuvable.",
    "BILLING_NUMBER_ERROR": "Numéro de facturation invalide.",
    "CANT_DEACTIVATED_COLLABORATOR_ERROR": "Impossible de désactiver ce collaborateur.",
    "CATEGORY_HAS_PRODUCTS_ERROR": "Catégorie contenant toujours des produits.",
    "CHRONOPOST_SHIPMENT_PARSING_ERROR": "Erreur lors de l'analyse des données retournées par Chronopost.",
    "COLLABORATOR_NOT_FOUND_ERROR": "Collaborateur introuvable.",
    "DEPARTURE_ADDRESS_CITY_INVALID_ERROR": "Ville de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_EMAIL_INVALID_ERROR": "Adresse email de contact de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_NAME_INVALID_ERROR": "Nom de contact de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_PHONE_INVALID_ERROR": "Numéro de téléphone de contact de départ invalide.",
    "DEPARTURE_ADDRESS_NAME_INVALID_ERROR": "Nom de l'adresse de départ invalide.",
    "DEPARTURE_ADDRESS_NOT_FOUND_ERROR": "Adresse de départ introuvable.",
    "DEPARTURE_ADDRESS_NUMBER_INVALID_ERROR": "Numéro de l'adresse de départ invalide.",
    "DEPARTURE_ADDRESS_STREET_INVALID_ERROR": "Rue de départ invalide.",
    "DEPARTURE_ADDRESS_ZIP_CODE_INVALID_ERROR": "Code postal de départ invalide.",
    "DUPLICATE_BOOMERANG_ID_ERROR": "L'identifiant Boomerang est déjà existant.",
    "DUPLICATE_NAME_ERROR": "Le nom est déjà existant.",
    "EMAIL_CLIENT_ERROR": "Adresse email du client invalide.",
    "EMAIL_COMMERCIAL_ERROR": "Adresse email de l'équipe commerciale invalide.",
    "EMAIL_PREPARER_ERROR": "Adresse email du préparateur logistique invalide.",
    "ESTIMATE_COST_ERROR": "Coût de réparation invalide.",
    "ESTIMATE_TRANSPORTER_COST_NOT_FOUND_ERROR": "Coût de transport estimatif invalide.",
    "EXPIRED_JWT_ERROR": "Token de connexion expiré. Veuillez vous reconnecter.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_HAS_LINKS_ERROR": "Connexion transporteur expressiste possédant encore des liaisons actives.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_SERVICE_ERROR": "Service de connexion transporteur expressiste invalide.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_ALREADY_EXISTS_ERROR": "Liaison de connexion transporteur expressiste déjà existante.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NETWORK_NOT_FOUND_ERROR": "Réseau lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NOT_FOUND_ERROR": "Liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_STORE_NOT_FOUND_ERROR": "Magasin lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_NOT_FOUND_ERROR": "Connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_HAS_CONNEXIONS_ERROR": "Suppression impossible, connexions encore attachées à ce transporteur expressiste.",
    "EXPRESSIST_TRANSPORTER_NOT_FOUND_ERROR": "Transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_STORE_NOT_FOUND_ERROR": "Magasin lié à ce transporteur expressiste introuvable.",
    "FAILED_UPLOAD_ERROR": "Échec de l'ajout des photos.",
    "FILE_NOT_FOUND_ERROR": "Fichier introuvable.",
    "GROUP_NOT_FOUND_ERROR": "Groupe introuvable.",
    "GROUP_NUMBER_ALREADY_USED_ERROR": "Numéro de groupe déjà utilisé pour ce réseau.",
    "GROUP_NUMBER_NOT_AVAILABLE_ERROR": "Numéro de groupe indisponible.",
    "GUARANTEE_DUPLICATE_TYPE_ERROR": "Garantie de ce type déjà existante pour cette sous-catégorie.",
    "GUARANTEE_EXTENSION_INVALID_PRODUCT_ERROR": "Produit inexistant.",
    "GUARANTEE_EXTENSION_INVALID_SERIAL_NUMBER_ERROR": "Numéro de série invalide.",
    "GUARANTEE_EXTENSION_NOT_FOUND_ERROR": "Extension de garantie introuvable.",
    "GUARANTEE_INVALID_NETWORK_ERROR": "Réseau inexistant.",
    "GUARANTEE_INVALID_PRODUCT_TYPE_ERROR": "Type de produit invalide.",
    "GUARANTEE_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie inexistante.",
    "GUARANTEE_NOT_FOUND_ERROR": "Garantie introuvable.",
    "INVALID_ACCOUNT_ERROR": "Compte invalide.",
    "INVALID_ADDITIONAL_REPAIR_COST_ERROR": "Surcoûts de réparation invalides.",
    "INVALID_ADDRESS_ERROR": "Adresse invalide.",
    "INVALID_BILLING_ID_ERROR": "ID de facturation invalide.",
    "INVALID_BODY_ERROR": "Données envoyées invalides.",
    "INVALID_BOOMERANG_ID_ERROR": "Identifiant Boomerang invalide.",
    "INVALID_BOOMERANG_NAME_ERROR": "Nom Boomerang invalide.",
    "INVALID_BREAKDOWN_DESCRIPTION_ERROR": "Description de panne invalide.",
    "INVALID_BREAKDOWN_QUESTION_ERROR": "Question de panne invalide.",
    "INVALID_CALLBACK_REF_ERROR": "Référence invalide.",
    "INVALID_CAPTCHA_TOKEN_ERROR": "Token reCAPTCHA invalide.",
    "INVALID_CATEGORY_ERROR": "Catégorie invalide.",
    "INVALID_CLIENT_NUMBER_ERROR": "Numéro client invalide.",
    "INVALID_CLIENT_PRICE_ERROR": "Prix client invalide.",
    "INVALID_COLLABORATOR_ERROR": "Collaborateur invalide.",
    "INVALID_COMMENT_ERROR": "Commentaire invalide.",
    "INVALID_COMMERCIAL_GUARANTEE_ERROR": "Garantie commerciale invalide.",
    "INVALID_COMPANY_ERROR": "Entreprise invalide.",
    "INVALID_COMPANY_NAME_ERROR": "Nom de l'entreprise invalide.",
    "INVALID_CONSTRAINTS_ERROR": "Collecte indisponible pour cette adresse. Veuillez modifier l'adresse ou réessayer plus tard.",
    "INVALID_CONTACT_EMAIL_ERROR": "Email de contact invalide.",
    "INVALID_CONTEXT_ERROR": "Accès non autorisé.",
    "INVALID_DELIVERY_UPDATE_ACTION_TYPE_ERROR": "Action non autorisée.",
    "INVALID_DEPOSIT_DATE_ERROR": "Date de dépôt invalide.",
    "INVALID_DESCRIPTION_ERROR": "Description invalide.",
    "INVALID_DOCUMENT_LIST_ERROR": "Document envoyé invalide.",
    "INVALID_DUPLICATE_EMAIL_ERROR": "Email déjà existant.",
    "INVALID_DUPLICATE_ROLE_TITLE_ERROR": "Titre du rôle déjà existant.",
    "INVALID_EMAIL_ERROR": "Email invalide.",
    "TNT_NO_TERMINAL_EVENT": "Aucun evenement final TNT n'a ete recu.",
    "TNT_SHIPMENT_FAILED": "La generation de l'expedition TNT a echoue.",
    "MISSING_EMAIL_ERROR": "Aucun email n'est renseigné sur votre compte.",
    "INVALID_EXPORT_TYPE_ERROR": "Type d'export demandé invalide.",
    "INVALID_FILE_ERROR": "Fichier invalide.",
    "INVALID_FILE_FORMAT_ERROR": "Fichier devant être au format PDF, JPG, JPEG ou PNG.",
    "INVALID_FILE_NAME_ERROR": "Nom de fichier invalide.",
    "INVALID_FILE_TO_HEAVY_ERROR": "Fichier trop lourd.",
    "INVALID_FIRSTNAME_ERROR": "Prénom invalide.",
    "INVALID_FORBIDDEN_PERMISSION_ERROR": "Action interdite.",
    "INVALID_FORMATION_ONE_ERROR": "Formation 1 invalide.",
    "INVALID_FORMATION_THREE_ERROR": "Formation 3 invalide.",
    "INVALID_FORMATION_TWO_ERROR": "Formation 2 invalide.",
    "INVALID_GUARANTEE_CONFIGURATION_ERROR": "Configuration de la garantie invalide.",
    "INVALID_GUARANTEE_ERROR": "Garantie introuvable.",
    "INVALID_GUARANTEE_TYPE_ERROR": "Type de garantie invalide.",
    "INVALID_ID_ERROR": "ID invalide.",
    "INVALID_INTERNAL_COMMAND_NUMBER_ERROR": "Numéro de commande invalide.",
    "INVALID_JOB_DESCRIPTION_ERROR": "Description du poste invalide.",
    "INVALID_JOB_TYPE_ERROR": "Type de poste invalide.",
    "INVALID_JWT_ERROR": "Token de connexion invalide. Veuillez vous reconnecter.",
    "INVALID_LASTNAME_ERROR": "Nom de famille invalide.",
    "INVALID_MANUFACTURER_ERROR": "Fabricant invalide.",
    "INVALID_MANUFACTURER_NUMBER_ERROR": "Numéro de fabricant invalide.",
    "INVALID_NETWORK_ERROR": "Réseau invalide.",
    "INVALID_NEW_CONFIRM_PASSWORD_ERROR": "Mots de passe non identiques.",
    "INVALID_PASSWORD_ERROR": "Mot de passe invalide.",
    "INVALID_PERMISSION_CONFIGURATION_ERROR": "Configuration des permissions invalide.",
    "INVALID_PERMISSION_TYPE_ERROR": "Type de permission invalide.",
    "INVALID_PHONE_NUMBER_ERROR": "Numéro de téléphone invalide.",
    "INVALID_PUBLIC_EMAIL_TOKEN_ERROR": "Ce lien est invalide ou a déjà été utilisé.",
    "INVALID_PRODUCTS_GUARANTEE_ERROR": "Garantie produit invalide.",
    "INVALID_PRODUCT_BREAKDOWN_ERROR": "Panne produit invalide.",
    "INVALID_PRODUCT_REQUEST_DRAFT_ID_ERROR": "Identifiant de brouillon invalide.",
    "INVALID_PRODUCT_REQUEST_NAMEPLATE_ERROR": "Merci d'ajouter une photo de plaque signalétique.",
    "INVALID_PRODUCT_REQUEST_QR_CODE_TOKEN_ERROR": "Token du QR code de la demande produit invalide.",
    "INVALID_PRODUCT_ERROR": "Produit invalide.",
    "PRODUCT_REQUEST_DRAFT_NOT_FOUND_ERROR": "Brouillon de demande produit introuvable.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_COMMENT_ERROR": "Commentaire invalide.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_OPTION_ERROR": "Option de demande préalable invalide.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_SUPPORT_NUMBER_ERROR": "Numéro de support de demande préalable invalide.",
    "INVALID_PURCHASE_ORDER_NUMBER_ERROR": "Numéro de commande invalide.",
    "INVALID_QUERY_PARAM_ERROR": "Filtres invalides.",
    "INVALID_RATING_EMAIL_TOKEN_ERROR": "Token invalide. Email non envoyé.",
    "INVALID_REPAIR_FILE_PACKAGE_EMAIL_TOKEN_ERROR": "Votre décision a déjà été prise en compte.",
    "INVALID_REPAIRER_ESTIMATE_EMAIL_TOKEN_ERROR": "Ce lien de validation est invalide ou a déjà été utilisé.",
    "INVALID_REAL_DELIVERY_DATE_ERROR": "Date de remise invalide.",
    "INVALID_RECYCLING_FOLDER_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de recyclage invalide.",
    "INVALID_RECYCLING_FOLDER_QR_CODE_TOKEN_ERROR": "Token généré par le QR code expiré.",
    "INVALID_RENTAL_FILE_CLIENT_EMAIL_ERROR": "Email du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_CLIENT_FULLNAME_ERROR": "Nom complet du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_CLIENT_PHONE_ERROR": "Téléphone du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_CITY_ERROR": "Ville de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_COUNTRY_ERROR": "Pays de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_NAME_ERROR": "Nom de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_NUMBER_ERROR": "Numéro de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_STREET_ERROR": "Rue de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_ZIP_CODE_ERROR": "Code postal de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_NAME_ERROR": "Nom de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_CITY_ERROR": "Ville de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_COUNTRY_ERROR": "Pays de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NAME_ERROR": "Nom de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NUMBER_ERROR": "Numéro de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_STREET_ERROR": "Rue de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_ZIP_CODE_ERROR": "Code postal de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DESIRED_CUSTOMER_RECEIPT_DATE_ERROR": "Date de réception souhaitée du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DESIRED_DEPOSIT_TYPE_ERROR": "Type de dépôt souhaité du dossier de location invalide.",
    "INVALID_RENTAL_FILE_FORCE_PASS_ERROR": "Passage forcé du dossier de location invalide.",
    "INVALID_RENTAL_FILE_PRODUCT_ID_ERROR": "Identifiant produit du dossier de location invalide.",
    "INVALID_RENTAL_FILE_PRODUCT_AVAILABILITY_ERROR": "Ce produit n'est plus disponible à la location. Veuillez sélectionner un autre produit.",
    "INVALID_RENTAL_FILE_QR_CODE_COLLABORATOR_ERROR": "Collaborateur du QR code du dossier de location invalide.",
    "INVALID_RENTAL_FILE_QR_CODE_TOKEN_ERROR": "Token du QR code du dossier de location invalide.",
    "INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR": "Token du QR code du dossier de location non utilisé.",
    "INVALID_RENTAL_FILE_RENTAL_REPAIR_FILE_ALREADY_EXISTS_ERROR": "Dossier de réparation déjà existant pour ce dossier de location.",
    "INVALID_RENTAL_FILE_REPAIR_FILE_ERROR": "Dossier de réparation du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_ERROR": "Statut du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRACKING_NUMBER_ERROR": "Numéro de suivi du transport aller du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRANSPORT_TYPE_ERROR": "Type de transport aller du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_UPDATE_DATE_ERROR": "Date de mise à jour du statut du dossier de location invalide.",
    "INVALID_REPAIRER_ERROR": "Réparateur invalide.",
    "INVALID_REPAIRER_EXPEDITION_DATE_ERROR": "Date d'expédition du réparateur invalide.",
    "INVALID_REPAIRER_REPAIR_FILE_NUMBER_ERROR": "Numéro de dossier de réparation invalide.",
    "INVALID_REPAIRER_SUPPORT_NUMBER_ERROR": "Numéro de dossier du réparateur invalide.",
    "INVALID_WORKSITE_CODE_ERROR": "Code chantier invalide.",
    "INVALID_REPAIR_FILE_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_LIMIT_DATE_ERROR": "Date limite du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_MAIL_CONTENT_ERROR": "Contenu du mail du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_MANUAL_STATUS_UPDATE_ERROR": "Mise à jour manuelle du statut du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_QR_CODE_TOKEN_ERROR": "Token du QR code du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_QUESTIONNAIRE_REDIRECT_URL_ERROR": "URL de redirection du questionnaire invalide.",
    "INVALID_REPAIR_FILE_RATING_ERROR": "Note du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_STATUS_DETAIL_ERROR": "Détail du statut du dossier de réparation invalide.",
    "INVALID_REP_CODE_ERROR": "Code représentant invalide.",
    "INVALID_REP_NUMBER_ERROR": "Numéro de représentant invalide.",
    "INVALID_REQUEST_ERROR": "Requête invalide.",
    "INVALID_RETURN_ADDRESS_ERROR": "Adresse de retour invalide.",
    "INVALID_ROLE_TYPE_ERROR": "Type du rôle invalide. Valeurs attendues : Administrateur ou Distributeur.",
    "INVALID_SERIAL_NUMBER_ERROR": "Numéro de série invalide.",
    "INVALID_STORE_ERROR": "Magasin invalide.",
    "INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide.",
    "INVALID_SUB_STATUS_ERROR": "Sous-statut invalide.",
    "INVALID_TEMPORARY_MESSAGE_END_DATE_ERROR": "Date de fin du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_FOOTER_ERROR": "Pied de page du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_MAIN_CONTENT_ERROR": "Contenu principal du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_START_DATE_ERROR": "Date de début du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_SUBTITLE_ERROR": "Sous-titre du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_SUB_CONTENT_ERROR": "Sous-contenu du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_TITLE_ERROR": "Titre du message temporaire invalide.",
    "INVALID_TITLE_ERROR": "Titre invalide.",
    "INVALID_TOKEN_ERROR": "Token de connexion invalide. Veuillez vous reconnecter.",
    "LOGIN_2FA_REQUIRED_ERROR": "Vérification 2FA requise.",
    "INVALID_LOGIN_2FA_CODE_ERROR": "Code de vérification invalide.",
    "EXPIRED_LOGIN_2FA_CODE_ERROR": "Code de vérification expiré.",
    "LOGIN_2FA_ATTEMPT_LIMIT_REACHED_ERROR": "Trop de tentatives de vérification. Veuillez recommencer la connexion.",
    "LOGIN_2FA_RESEND_LIMIT_REACHED_ERROR": "Renvoyez le code plus tard.",
    "INVALID_TRACK_NUMBER_ERROR": "Numéro de suivi invalide.",
    "INVALID_TYPE_ERROR": "Type de composant invalide.",
    "INVALID_UPDATE_STATUS_DATE_ERROR": "Date de mise à jour du statut invalide.",
    "ITECH_CLIENT_NOT_FOUND_ERROR": "Client introuvable pour le service ITECH. Veuillez contacter un administrateur Boomerang.",
    "ITECH_CLIENT_PARAM_MISSING_ERROR": "Paramètre client manquant pour le service ITECH.",
    "ITECH_DOCUMENT_INTEGRATION_ERROR": "Service ITECH a renvoyé : {params}. Veuillez contacter un administrateur Boomerang.",
    "ITECH_DOCUMENT_LINES_NOT_FOUND_ERROR": "Lignes du document ITECH introuvables.",
    "ITECH_ENVIRONMENT_NOT_CONFIGURED_ERROR": "Environnement non paramétré sur ITECH. Veuillez contacter un administrateur Boomerang.",
    "ITECH_GENERIC_ERROR": "Service ITECH incapable de délivrer une réponse complète.",
    "ITECH_HEADER_NOT_FOUND_ERROR": "En-tête ITECH introuvable.",
    "ITECH_INVALID_CREDENTIALS_ERROR": "Identifiants ITECH invalides.",
    "ITECH_INVALID_FILTER_ERROR": "Filtre ITECH invalide.",
    "ITECH_INVALID_FORMAT_ERROR": "Format ITECH invalide.",
    "ITECH_INVALID_OR_EXPIRED_TOKEN_ERROR": "Token ITECH invalide ou expiré.",
    "ITECH_LINE_ERRORS_PRESENT_ERROR": "Erreurs présentes dans les lignes ITECH.",
    "ITECH_MODIFICATION_FORBIDDEN_ERROR": "Modification ITECH interdite.",
    "ITECH_MODIFICATION_NOT_APPLIED_ERROR": "Modification ITECH non appliquée.",
    "ITECH_PRODUCTS_PARAM_MISSING_ERROR": "Paramètre produit manquant pour le service ITECH.",
    "ITECH_PRODUCT_NOT_FOUND_ERROR": "Service ITECH a renvoyé : {params}. Veuillez contacter un administrateur Boomerang.",
    "ITECH_REQUEST_CODE_NOT_FOUND_ERROR": "Code de requête ITECH introuvable.",
    "ITECH_TABLE_NOT_ACCESSIBLE_ERROR": "Table ITECH non accessible.",
    "ITECH_TABLE_NOT_FOUND_ERROR": "Table ITECH introuvable.",
    "LABOR_COST_ERROR": "Coût de main-d'œuvre invalide.",
    "LEAVE_REASON_INVALID_ERROR": "Raison de départ invalide.",
    "LIMIT_REACHED_ERROR": "Limite atteinte.",
    "MANUFACTURER_HAS_PRODUCTS_ERROR": "Fabricant contenant toujours des produits.",
    "MANUFACTURER_NOT_FOUND_ERROR": "Fabricant introuvable.",
    "MARGIN_ERROR": "Marge invalide.",
    "MODEL_SERIAL_NUMBER_NOT_FOUND_ERROR": "Numéro de série introuvable.",
    "MODEL_SERIAL_NUMBER_PRODUCT_TYPE_NOT_FOUND_ERROR": "Numéro de série introuvable.",
    "NETWORK_NOT_FOUND_ERROR": "Réseau introuvable.",
    "NETWORK_NOT_FOUND_FOR_LINK_ERROR": "Connexion au réseau introuvable.",
    "NOTIFICATION_INVALID_CONTENT_ERROR": "Contenu de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_MESSAGE_ERROR": "Message de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_STATUS_ERROR": "Statut de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_URL_ERROR": "URL de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_SUBTITLE_ERROR": "Sous-titre de la notification invalide.",
    "NOTIFICATION_INVALID_TITLE_ERROR": "Titre de la notification invalide.",
    "NOTIFICATION_NOT_FOUND_ERROR": "Notification introuvable.",
    "NOT_EMPTY_LIST_ERROR": "Rôle encore utilisé par certains comptes.",
    "NOT_FOUND_CLIENT_NUMBER_ERROR": "Numéro client introuvable.",
    "NOT_FOUND_ERROR": "Entité introuvable.",
    "NOT_FOUND_REGION_CODE_ERROR": "Code région introuvable.",
    "NOT_FOUND_SUPPLIER_CODE_ERROR": "Paramétrage nécessaire du compte client chez réparateur. Contacter BOOMERANG.",
    "NOT_FOUND_TEMPORARY_MESSAGE_ERROR": "Message temporaire introuvable.",
    "NO_MORE_GROUP_NUMBER_AVAILABLE_ERROR": "Aucun numéro de groupe disponible.",
    "NO_MULTI_COLLABORATOR_ACCOUNT_ERROR": "Compte n'acceptant pas plusieurs collaborateurs.",
    "OFFER_TYPE_ALREADY_EXIST_ERROR": "Type d'offre déjà existant.",
    "OFFER_TYPE_ERROR": "Type d'offre invalide.",
    "PACKAGE_AMPERE_INVALID_ERROR": "Ampérage du colis invalide.",
    "PACKAGE_CHECK_BOX_INVALID_ERROR": "Case à cocher du colis invalide.",
    "PACKAGE_LENGTH_INVALID_ERROR": "Longueur du colis invalide.",
    "PACKAGE_NOT_FOUND_ERROR": "Forfait introuvable.",
    "PACKAGE_WATT_HOUR_INVALID_ERROR": "Wattheure du colis invalide.",
    "PACKAGE_WATT_INVALID_ERROR": "Wattage du colis invalide.",
    "PACKAGE_WEIGHT_INVALID_ERROR": "Poids du colis invalide.",
    "PACKET_WIDTH_INVALID_ERROR": "Largeur du colis invalide.",
    "PRICING_TYPE_INVALID_ERROR": "Type de tarification invalide.",
    "PRODUCT_BOOMERANG_ID_INVALID_ERROR": "Identifiant Boomerang du produit invalide.",
    "PRODUCT_BREAKDOWN_ALREADY_ASSOCIATED_ERROR": "Panne produit déjà associée.",
    "PRODUCT_BREAKDOWN_INVALID_MANUFACTURER_ERROR": "Fabricant invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_INVALID_PRODUCT_ERROR": "Produit invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_NOT_ASSOCIATED_ERROR": "Panne non associée.",
    "PRODUCT_BREAKDOWN_NOT_FOUND_ERROR": "Panne introuvable.",
    "PRODUCT_BUY_FILE_PROOF_ERROR": "Preuve d'achat du produit invalide.",
    "PRODUCT_CONDITION_NOT_FOUND_ERROR": "État du produit introuvable.",
    "PRODUCT_END_COST_INVALID_ERROR": "Coût final du produit invalide.",
    "PRODUCT_END_STATUS_INVALID_ERROR": "Statut final du produit invalide.",
    "PRODUCT_FORCE_SUPPORT_FILE_PROOF_ERROR": "Preuve de prise en charge forcée invalide.",
    "PRODUCT_GUARANTEE_EXTENSION_FILE_PROOF_ERROR": "Preuve d'extension de garantie invalide.",
    "PRODUCT_IMAGE_REQUIRED_ERROR": "Image du produit requise.",
    "PRODUCT_INVALID_CATEGORY_ERROR": "Catégorie invalide.",
    "PRODUCT_INVALID_MANUFACTURER_ERROR": "Fabricant invalide.",
    "PRODUCT_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide.",
    "PRODUCT_INVALID_TYPE_ERROR": "Type de produit invalide.",
    "PRODUCT_NOT_FOUND_ERROR": "Produit introuvable.",
    "PRODUCT_QUESTION_MAX_QUESTIONS_ERROR": "Nombre maximum de questions atteint.",
    "PRODUCT_QUESTION_NOT_FOUND_ERROR": "Question introuvable.",
    "PRODUCT_SUB_PRODUCT_ALREADY_EXISTS_ERROR": "Sous-catégorie déjà associée.",
    "PRODUCT_SUB_PRODUCT_NOT_FOUND_ERROR": "Sous-catégorie introuvable.",
    "PRODUCT_VERSION_NOT_FOUND_ERROR": "Version du produit introuvable.",
    "PROSPECT_ADDITIONAL_INFO_ERROR": "Informations complémentaires du prospect invalides.",
    "PROSPECT_CONTACT_EMAIL_ERROR": "Email de contact du prospect invalide.",
    "RECONDITIONER_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de reconditionnement introuvable.",
    "RECONDITIONER_CENTER_LINK_STORE_NOT_FOUND_ERROR": "Liaison magasin centre de reconditionnement introuvable.",
    "RECONDITIONER_CENTER_NOT_FOUND_ERROR": "Centre de reconditionnement introuvable.",
    "RECONDITIONER_NOT_FOUND_ERROR": "Reconditionneur introuvable.",
    "RECYCLER_BAC_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre BAC introuvable.",
    "RECYCLER_BAC_HAS_CENTERS_ERROR": "Suppression impossible, BAC toujours associé à un ou plusieurs centres de reconditionnement ou de recyclage.",
    "RECYCLER_BAC_NOT_FOUND_ERROR": "Recycleur BAC introuvable.",
    "RECYCLER_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de recyclage introuvable.",
    "RECYCLER_CENTER_LINK_STORE_NOT_FOUND_ERROR": "Liaison magasin centre de recyclage introuvable.",
    "RECYCLER_CENTER_NOT_FOUND_ERROR": "Centre de recyclage introuvable.",
    "RECYCLER_NOT_FOUND_ERROR": "Recycleur introuvable.",
    "RECYCLING_BAC_NOT_FOUND_ERROR": "BAC de recyclage introuvable.",
    "RECYCLING_BOOMERANG_ID_NOT_FOUND_ERROR": "Aucun reconditionneur ou recycleur trouvé pour ce produit. Veuillez contacter l'administration Boomerang.",
    "RECYCLING_BUYBACK_PRICE_INVALID_PRODUCT_BOOMERANG_ID_ERROR": "Prix de rachat recyclage invalide pour ce produit.",
    "RECYCLING_FOLDER_ATTACHMENT_NOT_FOUND_ERROR": "Fichier attaché à ce dossier de recyclage introuvable.",
    "RECYCLING_FOLDER_NOT_FOUND_ERROR": "Dossier de recyclage introuvable.",
    "REGION_CODE_ASSOCIATION_ERROR": "Code de région toujours associé à un groupe ou un magasin.",
    "REGION_CODE_INVALID_COUNTRY_NAME_ERROR": "Nom du pays invalide.",
    "REGION_CODE_INVALID_REGION_CODE_ERROR": "Code de région invalide.",
    "REGION_CODE_INVALID_REGION_NAME_ERROR": "Nom de région invalide.",
    "REGION_CODE_NOT_FOUND_ERROR": "Code de région introuvable.",
    "RENTAL_FILE_ATTACHMENT_RENTAL_FILE_NOT_FOUND_ERROR": "Dossier de location introuvable.",
    "RENTAL_FILE_DELIVERY_ADDRESS_NOT_FOUND_ERROR": "Adresse de livraison du dossier de location introuvable.",
    "RENTAL_FILE_NETWORK_NOT_FOUND_ERROR": "Réseau du dossier de location introuvable.",
    "RENTAL_FILE_NOT_FOUND_ERROR": "Dossier de location introuvable.",
    "RENTAL_FILE_RENTAL_PRODUCT_ADDITIONAL_COST_NOT_FOUND_ERROR": "Surcoût du produit de location introuvable.",
    "RENTAL_FILE_RENTAL_PRODUCT_PACKAGE_NOT_FOUND_ERROR": "Colis du produit de location introuvable.",
    "RENTAL_FILE_STATUS_NOT_FOUND_ERROR": "Statut du dossier de location introuvable.",
    "RENTAL_FILE_STORE_NOT_FOUND_ERROR": "Magasin du dossier de location introuvable.",
    "RENTAL_PAGINATED_PRODUCT_REPAIR_FILE_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de réparation du produit de location invalide.",
    "RENTAL_PRODUCT_INVALID_AVAILABILITY_STATUS_ERROR": "Statut de disponibilité du produit de location invalide.",
    "RENTAL_PRODUCT_NOT_FOUND_ERROR": "Produit de location introuvable.",
    "REPAIRER_ESTIMATE_ALREADY_EXIST_ERROR": "Devis du réparateur déjà existant.",
    "REPAIRER_ESTIMATE_NOT_FOUND_ERROR": "Devis du réparateur introuvable.",
    "REPAIRER_ESTIMATE_OPTION_ERROR": "Option du devis du réparateur invalide.",
    "REPAIRER_NOT_FOUND_ERROR": "Réparateur introuvable.",
    "REPAIR_CENTER_INVALID_REPAIRER_ERROR": "Réparateur introuvable pour ce centre de réparation.",
    "REPAIR_CENTER_LINK_CATEGORY_NOT_LINKED_ERROR": "Liaison catégorie - centre de réparation introuvable.",
    "REPAIR_CENTER_LINK_INVALID_CATEGORY_ERROR": "Catégorie invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_MANUFACTURER_ERROR": "Fabricant invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_NETWORK_ERROR": "Réseau invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_REPAIR_CENTER_ERROR": "Centre de réparation invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_STORE_ERROR": "Magasin invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_MANUFACTURER_NOT_LINKED_ERROR": "Fabricant non lié à cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de réparation introuvable.",
    "REPAIR_CENTER_LINK_STORE_NOT_LINKED_ERROR": "Magasin non lié à cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_SUB_CATEGORY_NOT_LINKED_ERROR": "Sous-catégorie non liée à cette liaison centre de réparation.",
    "REPAIR_CENTER_NOT_FOUND_ERROR": "Centre de réparation introuvable.",
    "REPAIR_FILE_ATTACHMENT_NOT_FOUND_ERROR": "Pièce jointe du dossier de réparation introuvable.",
    "REPAIR_FILE_ATTACHMENT_TYPE_ERROR": "Type de pièce jointe du dossier de réparation invalide.",
    "REPAIR_FILE_COMMENT_NOT_FOUND_ERROR": "Commentaire du dossier de réparation introuvable.",
    "REPAIR_FILE_NOT_FOUND_ERROR": "Dossier de réparation introuvable.",
    "REPAIR_FILE_REPAIR_CENTER_NOT_FOUND_ERROR": "Aucun centre de réparation n'est associé à ce dossier de réparation.",
    "REPAIR_FILE_PROSPECT_DOCUMENT_NOT_FOUND_ERROR": "Document prospect du dossier de réparation introuvable.",
    "REPAIR_FILE_PROSPECT_PICTURE_NOT_FOUND_ERROR": "Photo prospect du dossier de réparation introuvable.",
    "REPAIR_FILE_STATUS_CLIENT_PHONE_NOTIFICATION_TYPE_ERROR": "Type de notification téléphonique du client invalide.",
    "REPAIR_FILE_STATUS_CLIENT_TAKEOVER_TYPE_ERROR": "Type de prise en charge client invalide.",
    "REPAIR_FILE_STATUS_DETAIL_ERROR": "Détail du statut du dossier de réparation invalide.",
    "REPAIR_FILE_STORE_ERP_INTERNAL_ERROR": "Erreur interne ERP du magasin pour le dossier de réparation.",
    "RETURN_ADDRESS_CITY_INVALID_ERROR": "Ville de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_EMAIL_INVALID_ERROR": "Email de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_NAME_INVALID_ERROR": "Nom de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_PHONE_INVALID_ERROR": "Téléphone de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_NAME_INVALID_ERROR": "Nom de l'adresse de retour invalide.",
    "RETURN_ADDRESS_NUMBER_INVALID_ERROR": "Numéro de l'adresse de retour invalide.",
    "RETURN_ADDRESS_STREET_INVALID_ERROR": "Rue de l'adresse de retour invalide.",
    "RETURN_ADDRESS_ZIP_CODE_INVALID_ERROR": "Code postal de l'adresse de retour invalide.",
    "SHIPPING_COLLECT_DATE_INVALID_ERROR": "Date de collecte d'expédition invalide.",
    "SHIPPING_COLLECT_STATUS_INVALID_ERROR": "Statut de collecte d'expédition invalide.",
    "STATUS_ERROR": "Statut invalide.",
    "STORE_INVALID_GROUP_ERROR": "Groupe introuvable pour ce magasin.",
    "STORE_INVALID_MANUFACTURER_ERROR": "Fabricant introuvable pour ce magasin.",
    "STORE_INVALID_RATING_REDIRECT_ERROR": "Lien de redirection introuvable pour ce magasin.",
    "STORE_INVALID_REGION_CODE_ERROR": "Code de région introuvable pour ce magasin.",
    "STORE_INVALID_REPAIRER_ERROR": "Réparateur introuvable pour ce magasin.",
    "STORE_INVALID_REPAIR_CENTER_ERROR": "Centre de réparation introuvable pour ce magasin.",
    "STORE_INVALID_SIRET_ERROR": "SIRET invalide.",
    "STORE_MILWAUKEE_ACCOUNT_REQUIRED_ERROR": "Compte Milwaukee requis pour ce magasin.",
    "STORE_MILWAUKEE_PASSWORD_REQUIRED_ERROR": "Mot de passe Milwaukee requis pour ce magasin.",
    "STORE_NOT_FOUND_ERROR": "Magasin introuvable.",
    "STORE_NOT_FOUND_FOR_LINK_ERROR": "Magasin introuvable pour cette liaison.",
    "SUB_CATEGORY_HAS_PRODUCTS_ERROR": "Sous-catégorie contenant toujours des produits.",
    "SUB_CATEGORY_NOT_FOUND_ERROR": "Sous-catégorie introuvable.",
    "TOO_MANY_REPAIR_CENTER_FOUND_ERROR": "Trop de centres de réparation trouvés.",
    "TOTAL_COST_ERROR": "Coût total invalide.",
    "TRANSPORTER_EXPRESSIST_INVALID_ERROR": "Transporteur expressiste invalide.",
    "TRANSPORTER_EXPRESSIST_NOT_FOUND_ERROR": "Transporteur expressiste introuvable.",
    "TRANSPORTER_MODALITY_INVALID_ERROR": "Modalité du transporteur invalide.",
    "TRANSPORTER_NAME_INVALID_ERROR": "Nom du transporteur invalide.",
    "TRANSPORTER_NOT_FOUND_ERROR": "Transporteur introuvable.",
    "TRANSPORTER_TYPE_INVALID_ERROR": "Type de transporteur invalide.",
    "TRANSPORT_COST_ERROR": "Coût de transport invalide.",
    "TRANSPORT_PACKAGE_NOT_FOUND_ERROR": "Forfait transport introuvable.",
    "UNAUTHORIZED_ENTITY_ACCESS_ERROR": "Accès non autorisé à certaines ressources.",
    "UNEXPECTED_ERROR": "Erreur inattendue générée.",
    "UNSUPPORTED_ATTACHMENT_TYPE_ERROR": "Type de pièce jointe non supporté.",
    "USER_ALREADY_EXISTS_ERROR": "Utilisateur déjà existant."
  },
  "DISCONNECT": {
    "MESSAGE": "Vous avez été déconnecté"
  },
  "STATUS": {
    "PENDING": "En attente",
    "INACTIVE": "Inactif",
    "ACTIVE": "Actif",
    "DELETED": "Supprimé"
  },
  "JOB_LIST": {
    "STORE_SALESMAN_JOB": "Vendeur magasin",
    "TELEPHONE_SALESMAN_JOB": "Vendeur téléphonique",
    "TRAVELING_SALESMAN_JOB": "Vendeur Itinérant",
    "STORE_MANAGER_JOB": "Responsable Magasin",
    "GEOGRAPHIC_MANAGER_JOB": "Manager Géographique",
    "RSE_DEPARTMENT_JOB": "Direction RSE",
    "MARKETING_DEPARTMENT_JOB": "Direction Marketing",
    "PURCHASING_DEPARTMENT_JOB": "Direction Achat/Opérations",
    "OTHER_JOB": "Autre"
  },
  "LAYOUTS": {
    "DASHBOARD": "Accueil",
    "FOLDER": "Dossier",
    "USERS": "Utilisateurs",
    "TRANSPORTER": "Transporteur",
    "HELP": "Aide",
    "LOGOUT": "Déconnexion",
    "NOTIFICATIONS": "Notifications",
    "PROFILE": "Collaborateur",
    "RECYCLING_REPORT": "Rapport de performance",
    "ENVIRONMENTAL_PERFORMANCE_REPORT": "Analyse performance environnementale"
  },
  "MANAGEMENT_PAGE": {
    "TITLE": {
      "HEADER_USER": "Utilisateurs"
    },
    "BUTTON": {
      "NEW_ACCOUNT": "Nouvel utilisateur",
      "ACCOUNT": "Utilisateurs"
    }
  },
  "USERS_PAGE": {
    "TITLE": "Utilisateurs",
    "SUBTITLE": "Liste des utilisateurs rattachés aux magasins auxquels vous avez accès.",
    "SEARCH": "Rechercher un utilisateur",
    "ROLE_FILTER": "Rôle",
    "STATUS_FILTER": "Statut",
    "DETAIL": {
      "TITLE": "Détail d'un utilisateur",
      "SUB_HEADER": "Utilisateur",
      "GENERAL_INFO": "Informations générales",
      "USER_SCOPE": "Périmètre utilisateur",
      "GROUP_NAME": "Groupement",
      "STORE_NAME": "Magasin",
      "SUBTITLES": {
        "COLLABORATORS": "Liste des collaborateurs rattachés à {accountEmail}",
        "GROUPS": "Liste des groupements rattachés à {accountEmail}",
        "STORES": "Liste des magasins rattachés à {accountEmail}"
      },
      "LOAD_ERROR": "Impossible de charger cet utilisateur.",
      "RETRY": "Réessayer",
      "ACCOUNT": "Informations du compte",
      "ADDITIONAL": "Informations complémentaires",
      "COLLABORATORS": "Collaborateurs",
      "GROUPS": "Groupements",
      "STORES": "Magasins",
      "DEACTIVATE_CONFIRM": "Désactiver {collaborator} ?",
      "FIELDS": {
        "ID": "ID",
        "EMAIL": "Login / Email",
        "APPLICANT_EMAIL": "Email demandeur",
        "PHONE_NUMBER": "Numéro de téléphone",
        "STATUS": "Statut",
        "ROLE": "Rôle",
        "NETWORK": "Réseau",
        "COLLABORATION_MODE": "Structure du compte",
        "REGION_CODE": "Zone",
        "ACTIVATION_DATE": "Date d'activation",
        "FORMATION_ONE": "Formation 1",
        "FORMATION_TWO": "Formation 2",
        "FORMATION_THREE": "Formation 3",
        "DESCRIPTION": "Description",
        "SUB_STATUS": "Sous-statut"
      }
    },
    "EDIT": {
      "TITLE": "Modifier un utilisateur",
      "COLLABORATION_MODE": "Type de compte",
      "SCOPE": "Périmètre utilisateur",
      "SCOPE_NOTE": "Seuls vos magasins et groupements accessibles sont affichés. Les autres rattachements sont conservés.",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple",
      "SUCCESS": "Utilisateur modifié"
    },
    "TABLE": {
      "ROLE": "Rôle",
      "USER": "Utilisateur",
      "APPLICANT": "Demandeur",
      "FILES": "Dossiers",
      "GROUPS": "Groupements",
      "STATUS": "Statut",
      "INFO_QUALITY": "Qualité infos",
      "DESCRIPTION": "Description",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "STATUS": {
      "pending": "En attente",
      "inactive": "Inactif",
      "active": "Actif",
      "deleted": "Supprimé"
    },
    "INFO_QUALITY": {
      "missing": "Manquante",
      "partial": "Partielle",
      "complete": "Complète"
    }
  },
  "ACCOUNT_PAGE": {
    "PLACEHOLDER": {
      "ROLE": "Sélectionner le rôle",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "ID": "ID",
      "USER": "Utilisateur",
      "APPLICANT": "Demandeur",
      "ROLE": "Rôle",
      "FILE": "Nombre de dossier",
      "GROUPS": "Groupement",
      "STATUS": "Statut",
      "INFO_QUALITY": "Formation",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous statut",
      "ACTIVATED_DATE": "Date d'activation",
      "LOADING_USER": "Chargement des utilisateurs...",
      "NO_USER": "Aucun utilisateur",
      "OTHER": "autre",
      "OTHERS": "autres"
    }
  },
  "DETAIL_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un utilisateur",
      "COLLABORATOR": "Collaborateurs",
      "GROUPS": "Groupements",
      "STORES": "Magasins"
    },
    "LABEL": {
      "ID": "ID",
      "EMAIL": "Login / Email",
      "APPLICANT_EMAIL": "Email demandeur",
      "PHONE_NUMBER": "Numéro de téléphone",
      "STATUS": "Statut",
      "ROLE": "Rôle",
      "NETWORK": "Réseau",
      "AREA": "Zone géographique",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "NOT_SPECIFIED": "Non renseigné",
      "ACTIVATION_DATE": "Date d'activation",
      "FORMATION_ONE": "Première formation",
      "FORMATION_TWO": "Seconde formation",
      "FORMATION_THREE": "Troisième formation",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous statut"
    },
    "TABLE": {
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "STATUS": "Statut",
      "DATE": "Date",
      "LOADING_COLLABORATORS": "Chargement des collaborateurs...",
      "NO_COLLABORATOR": "Aucun collaborateur",
      "GROUP_NAME": "Groupement",
      "STORE_NAME": "Magasin"
    },
    "BUTTON": {
      "NEW_COLLABORATOR": "Ajouter un collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "",
      "ERROR": ""
    },
    "MODAL": {
      "TITLE": "Supprimer un collaborateur",
      "MESSAGE": "Voulez-vous vraiment supprimer {collaborator}?",
      "WARNING": "Cette action est irréversible."
    }
  },
  "EDIT_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un utilisateur",
      "SUBTITLE": "Formulaire d'édition d'un utilisateur"
    },
    "FORM": {
      "LABEL_ACCOUNT_TYPE": "Type de compte",
      "ACCOUNT_INFO": "Information demandeur",
      "ADDITIONAL_INFO": "Information complementaire",
      "USER_SCOPE": "Périmètre utilisateur",
      "LABEL_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL": "Login / Email",
      "LABEL_APPLICANT_EMAIL": "Email demandeur",
      "LABEL_STATUS": "Statut",
      "LABEL_FORMATION_ONE": "Première formation",
      "LABEL_FORMATION_TWO": "Seconde formation",
      "LABEL_FORMATION_THREE": "Troisième formation",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_SUB_STATUS": "Sous statut",
      "LABEL_ROLE": "Rôle",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUPS": "Groupements",
      "LABEL_STORES": "Magasins",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition de l'utilisateur"
    },
    "MESSAGE": {
      "SUCCESS": "L'utilisateur a été modifié avec succès",
      "ERROR": "Impossible de modifier l'utilisateur"
    }
  },
  "FINALIZATION_PAGE": {
    "RETURN_INVOICE_CONFIRMATION": "Attention ! Avez-vous bien vérifié que la facture du réparateur n’était pas dans le colis destiné à votre client ?",
    "TITLE": "Finalisation du dossier nº{number}",
    "SUBTITLE": "Suivez les 3 étapes obligatoires ci-dessous pour déclencher le suivi de votre réparation. Aucune ne peut être omise.",
    "SUBTITLE_WITHOUT_TRACKING": "Suivez les 3 étapes ci-dessous pour déclencher le suivi de votre réparation.",
    "REPAIRER_NUMBER": "Numéro de réparateur",
    "REPAIRER_NUMBER_PLACEHOLDER": "Saisir le numéro",
    "DOWNLOAD": "Télécharger",
    "REDOWNLOAD": "Re-télécharger",
    "TRACKING_NUMBER": "Numéro de suivi",
    "TRACKING_NUMBER_PLACEHOLDER": "XR123456789FR",
    "FINISH_LATER": "Terminer plus tard",
    "ACTIVATE_TRACKING": "Déclencher le suivi du dossier",
    "SECTIONS": {
      "TRANSPORT_DETAILS": "Renseigner les informations de transport",
      "DOCUMENTS": "Imprimer les documents pour le réparateur",
      "CLIENT_DOCUMENTS": "Imprimer les documents pour le client",
      "CLIENT_DOCUMENTS_SUBTITLE": "Ces documents doivent impérativement être glissés dans le colis. Sans eux, votre produit ne pourra pas être pris en charge.",
      "DOCUMENTS_SUBTITLE": "Ces documents doivent impérativement être glissés dans le colis. Sans eux, votre produit ne pourra pas être pris en charge ni réparé par le technicien.",
      "ACTIVATE_TRACKING": "Activer le suivi du dossier",
      "ACTIVATE_TRACKING_SUBTITLE": "En confirmant, vous déclarez avoir renseigné le numéro de suivi et placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé.",
      "ACTIVATE_WITHOUT_TRACKING_SUBTITLE": "En confirmant, vous déclarez avoir placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé."
    },
    "DOCUMENTS_INCLUDED": {
      "DELIVERY_NOTE": "Bon de livraison",
      "REPAIR_ORDER": "Ordre de réparation",
      "GUARANTEE_EXTENSION_PROOF": "Justificatif d'extension de garantie",
      "PURCHASE_PROOF": "Justificatif d'achat",
      "ASBESTOS_PROOF": "Justificatif amiante",
      "FORCE_SUPPORT_PROOF": "Justificatif de prise en charge forcée",
      "BATTERY_LABEL": "Étiquette batterie",
      "TRANSPORT_LABEL": "Étiquette de transport",
      "TRANSPORTER_REPAIRER_DOCUMENT": "Document transporteur pour le réparateur"
    },
    "DOCUMENT_PLACEMENTS": {
      "STICK_ON_PARCEL": "À coller sur le colis",
      "PUT_IN_PARCEL": "À mettre dans le colis"
    },
    "MESSAGE": {
      "LOAD_ERROR": "Le dossier ou la liste des documents n'a pas pu être chargé.",
      "SUCCESS": "Dossier finalisé"
    }
  },
  "COMMON": {
    "MISSING_INFORMATION": "Informations manquantes",
    "ORDER_NUMBER": "N° de commande",
    "COST": "Coût",
    "COST_EXCLUSIVE_TAX": "Coût (HT)",
    "ADDRESS": {
      "STREET_ADDRESS": "Adresse (numéro et rue)",
      "ENTER_MANUALLY": "Saisir l’adresse manuellement",
      "USE_AUTOCOMPLETE": "Utiliser la saisie automatique d’adresse",
      "MISSING_NUMBER": "Ajoutez le numéro de rue pour compléter cette adresse.",
      "COPY_TO_RETURN": "Utiliser également ces informations pour l’adresse de retour",
      "GOOGLE_ATTRIBUTION": "Google Maps"
    },
    "AUTH_LINK": {
      "INVALID_TITLE": "Lien expiré ou invalide",
      "INVALID_MESSAGE": "Utilisez le lien reçu par email ou demandez un nouveau lien à l’expéditeur."
    },
    "PUBLIC_PAGE": {
      "LOADING": "Chargement…",
      "INVALID_TITLE": "Lien expiré ou invalide",
      "INVALID_MESSAGE": "Demandez un nouveau lien ou QR code depuis le dossier, ou contactez l’expéditeur.",
      "FAILED_TITLE": "Impossible de charger la page",
      "FAILED_MESSAGE": "La page n’a pas pu être chargée. Vérifiez votre connexion et réessayez.",
      "RETRY": "Réessayer"
    },
    "ADDRESS_FIELDS": {
      "NAME": "Nom de l'adresse",
      "NUMBER": "Numéro",
      "STREET": "Rue",
      "ZIP_CODE": "Code postal",
      "CITY": "Ville",
      "COUNTRY": "Pays"
    },
    "REQUIRED": "Obligatoire",
    "UNITS": { "VOLT": "V", "AMPERE_HOUR": "Ah", "WATT_HOUR": "Wh" },
    "FILTER": {
      "SEARCH": "Rechercher",
      "EXPORT": "Exporter",
      "SHOW_FILTERS": "Afficher les filtres"
    },
    "LOADING": "Chargement...",
    "MESSAGE": {
      "ADD_ATTACHMENT_SUCCESS": "La pièce jointe a été ajoutée avec succès.",
      "REMOVE_ATTACHMENT_SUCCESS": "La pièce jointe a été supprimée avec succès."
    },
    "INPUTS": {
      "OTHER_SELECTED": "+{count} autre",
      "OTHERS_SELECTED": "+{count} autres"
    },
    "BUTTON": {
      "YES": "Oui",
      "ADD": "Ajouter",
      "NO": "Non",
      "NEXT_STEP": "Prochaine étape",
      "BACK": "Retour",
      "DETAIL": "Détails",
      "UPDATE": "Mettre à jour",
      "EDIT": "Modifier",
      "CREATE": "Créer",
      "DELETE": "Supprimer",
      "DEACTIVATE": "Désactiver",
      "LOAD_MORE": "Charger plus",
      "CANCEL": "Annuler",
      "CONTINUE": "Continuer",
      "SAVE": "Enregistrer",
      "VALIDATE": "Valider",
      "CONFIRM": "Confirmer",
      "LEAVE": "Quitter",
      "SEND": "Envoyer",
      "RECYCLE": "Recycler",
      "FINISH": "Terminer",
      "REMOVE": "Supprimer",
      "CLOSE": "Fermer",
      "RETRY": "Réessayer"
    },
    "CREATION_IN_PROGRESS": "Dossier en cours de création",
    "FILE_UPLOAD": {
      "DRAG_HERE": "Glissez votre fichier ici",
      "OR": "ou ",
      "BROWSE": "parcourez vos fichiers",
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, JPEG, PNG",
      "INVALID_FORMAT": "Ce format de fichier n'est pas accepté."
    },
    "GENERIC_EXPORT_SUCCESS": "L'export a été effectué et sera envoyé par mail",
    "TABLE": {
      "OTHER": "autre",
      "OTHERS": "autres",
      "NO_PRODUCT": "Aucun produit"
    },
    "MULTI_SELECT": {
      "SELECT_ALL": "Tout sélectionner",
      "UNSELECT_ALL": "Tout désélectionner"
    },
    "NAVIGATION": {
      "DASHBOARD": "Accueil",
      "REPAIR_FILES": "Dossiers de réparation",
      "USERS": "Utilisateurs",
      "PROFILE": "Profil",
      "ENVIRONMENTAL_PERFORMANCE_REPORT": "Analyse performance environnementale",
      "HELP": "Aide",
      "LOGOUT": "Déconnexion"
    },
    "PRODUCT_TYPE": {
      "MACHINE": "Machine",
      "BATTERY": "Batterie",
      "CHARGER": "Chargeur",
      "PRODUCT": "Produit",
      "ACCESSORY_ONE": "Accessoire 1",
      "ACCESSORY_TWO": "Accessoire 2",
      "BRIEFCASE": "Mallette",
      "PREMIUM_CONSUMABLE": "Consommable Premium",
      "PPE": "Équipement de protection individuelle",
      "EQUIPMENT": "Équipement",
      "PALLET": "Palette"
    },
    "PRICING_TYPE": {
      "PACKAGE": "Forfait",
      "ESTIMATE": "Devis"
    },
    "STATUS_MACRO": {
      "DRAFT": "Brouillon",
      "IN_CREATION": "En création",
      "IN_CREATION_ESTIMATE": "En création - devis",
      "IN_CREATION_PROSPECT": "En création - demande",
      "TRANSPORT_GO": "Transport aller",
      "RECEPTION_AT_REPAIRER": "Réception réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Diagnostic réparateur reçu",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "Diagnostic réparateur traité",
      "ESTIMATE_SENT_TO_CUSTOMER": "Décision client - devis",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Devis réparateur validé",
      "IN_REPARATION": "Réparation",
      "SENT_BACK_BY_REPAIRER": "Transport retour",
      "RECEIPT_AT_STORE": "Réception magasin",
      "SENT_AVAILABLE_TO_CUSTOMER": "Attente collecte",
      "TAKEOVER_BY_CUSTOMER": "Clôturé",
      "NETWORK_BILLING": "Facturation",
      "FINISHED": "Terminé",
      "ABORT_BY_CUSTOMER": "Abandon par client",
      "DELETED": "Supprimé"
    },
    "STATUS_DETAIL": {
      "GUARANTEE_EVALUATED": "Création de dossier",
      "PRICING_SENT_TO_CUSTOMER": "Devis forfait",
      "PRICING_EVALUATED": "Création de dossier",
      "INFORMATION_RETRIEVED": "N° de commande",
      "INTERNAL_COMMAND_NUMBER_LINKED": "Sélection du transport",
      "TRANSPORTER_REPAIR_FILE_TRANSFER": "Finalisation du dossier",
      "FINALIZE_REPAIR_FILE": "Finalisation du dossier",
      "REPAIR_FILE_CREATED": "Transfert du produit",
      "COLLECTION_TO_REPAIRER": "Enlèvement Aller",
      "RECEPTION_AT_REPAIRER": "Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Devis envoyé par le fabricant",
      "ESTIMATE_CREATED": "Réception devis réparateur",
      "ESTIMATE_SENT_TO_CUSTOMER": "Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Décision client envoyée au réparateur",
      "IN_REPARATION": "En réparation",
      "SENT_BACK_BY_REPAIRER": "Expédition par réparateur",
      "RECEIPT_AT_STORE": "Réception en magasin",
      "SENT_AVAILABLE_TO_CUSTOMER": "Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "Remise au client - Cloturé",
      "NETWORK_BILLING": "Facturation",
      "FINISHED": "Terminé",
      "ABORT_BY_CUSTOMER": "Abandonné",
      "DELETED": "Supprimé"
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
      "DEFAULT": "Dossier sans remise client",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre"
    },
    "EURO": "€",
    "PERCENT": "%",
    "DATE_PLACEHOLDER": "JJ/MM/AAAA",
    "DAYS": " jours",
    "DAY": " jour",
    "KILOGRAM": "kg",
    "TONNE": "t",
    "CENTIMETER": "cm",
    "EXCLUSIVE_TAX": " (HT)",
    "NO_DATA": "Aucun résultat",
    "NO_VALUE": "-",
    "WEIGHT": "Poids",
    "WIDTH": "Largeur",
    "LENGTH": "Longueur",
    "NOT_AUTHORIZED_MESSAGE": "Vous n'êtes pas autorisé à voir cette page, merci de contacter un administrateur",
    "NOT_AUTHORIZED_ACTION_MESSAGE": "Vous n'êtes pas autorisé à effectuer cette action, merci de contacter un administrateur"
  },
  "KEY_ACCOUNT_REPAIR_FILE_OPENING_WARNING": {
    "TITLE": "Dossier initié directement par le client",
    "INTRO": "Pensez bien à :",
    "BILLING_REMINDER": "Facturer la prestation via votre ERP.",
    "REFERENCE_REMINDER": "Utiliser les références indiquées par le client :",
    "CALLBACK_REF": "REF À RAPPELER :",
    "WORKSITE_CODE": "N° Chantier :",
    "DELIVERY_REMINDER": "Le client souhaite être livré directement à l’adresse suivante",
    "ACKNOWLEDGEMENT": "J’ai bien pris en compte ces éléments."
  },
  "DASHBOARD": {
    "TITLE": "Bienvenue sur Boomerang",
    "BUTTON": {
      "NEW_REPAIR_FILE": "Nouveau dossier de Réparation / Prise en charge",
      "RECYCLE": "Recycler",
      "RECONDITION": "Reconditionner"
    },
    "FOOTER": {
      "AVERAGE_CUSTOMER": ">85%",
      "AVERAGE_RESPONSE": " de devis automatiques",
      "GUARANTEE": "Jusqu'à 6 mois de garantie Boomerang",
      "PRODUCT_LABEL": "produits",
      "MANUFACTURER_LABEL": "marques",
      "BUTTON": "Se former à Boomerang avec nos équipes"
    },
    "REPAIR_FILE_FINALIZED": {
      "TITLE": "Calculateur Impact écologique (en cours)",
      "CO2": "- CO²"
    }
  },
  "LEAVE_MODAL": {
    "SIMPLE_MODAL": {
      "TITLE": "Quitter la création du dossier ?",
      "MESSAGE": "Ce brouillon de dossier sera supprimé. Cette action est définitive.",
      "VALIDATION_BUTTON": "Supprimer le brouillon",
      "CANCEL_BUTTON": "Continuer la création"
    },
    "STEPPER_MODAL": {
      "COUNT_1": "1/2",
      "COUNT_2": "2/2",
      "STEP_1": {
        "TITLE": "Vous quittez le dossier",
        "SUBTITLE": "Choisissez si vous souhaitez reprendre ce dossier plus tard ou l'abandonner.",
        "VALIDATION_BUTTON": "Revenir sur la création de dossier plus tard",
        "CANCEL_BUTTON": "Abandonner le dossier",
        "CANCEL_AND_RECYCLE_BUTTON": "Abandonner le dossier et/ou RECYCLER"
      },
      "STEP_2": {
        "ABANDON_HELP": "L'abandon clôture le dossier avec le motif sélectionné.",
        "DETAIL": "Motif",
        "REASON": {
          "DEADLINE_TOO_LONG": "Délai trop long",
          "LEAVE_MESSAGE": "Le dossier sera visible dans le tableau sous le statut « Abandon »",
          "NO_PACKAGE": "Pas de forfait",
          "OTHER": "Autre",
          "REPAIR_TOO_EXPENSIVE": "Forfait trop cher, pas d'achat immédiat",
          "REPAIR_TOO_EXPENSIVE_AND": {
            "BUY_SAME_BRAND": "MÊME MARQUE",
            "BUY_OTHER_BRAND": "AUTRE MARQUE",
            "COMMON": "Réparation trop chère, rachat d’un produit "
          }
        },
        "RECYCLING": {
          "TITLE": "Solution Recyclage/Rachat",
          "BUYBACK_MESSAGE": "Reprise jusqu'à {buybackPrice}€ en fonction de l'état"
        },
        "SUBMIT": {
          "CANCEL": "Abandonner le dossier",
          "RECYCLING": "Proposer solution Recyclage/Rachat"
        },
        "TITLE": "Pour quels motifs ?",
        "SUBTITLE": "Le dossier sera visible dans le tableau sous le statut « Abandon »."
      }
    }
  },
  "FILE_STEP_PRODUCT": {
    "CLIENT_NUMBER_MODAL": {
      "ERROR": {
        "CLIENT_NUMBER_NOT_GOOD_FORMAT": "Le n° de client doit comporter {value} caractères"
      },
      "LABEL": {
        "CLIENT_NUMBER": "N° Compte client"
      },
      "MESSAGE_1": "Merci d'indiquer ici votre le N° de carte de votre client.",
      "MESSAGE_2": "(Pensez à utiliser une douchette/scanette pour le code barre)",
      "PLACEHOLDER": {
        "CLIENT_NUMBER": "Ex: 20........"
      },
      "TITLE": "Renseignez un n° de compte client"
    },
    "TITLE": "Sélectionnez le produit",
    "SUB_TITLE": "Produits les plus populaires",
    "LOAD_ERROR": "Impossible de charger les produits.",
    "STORE_UNAVAILABLE": "Vous n'avez plus accès au magasin associé à ce dossier.",
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la marque",
      "CATEGORY": "Sélectionnez la gamme",
      "SUB_CATEGORY": "Sélectionnez la sous-gamme",
      "NO_PRODUCT": "Aucun produit"
    },
    "SELECT": {
      "MANUFACTURER": "Quelle est la marque du produit ?",
      "CATEGORY": "Quelle est la gamme du produit ?",
      "SUB_CATEGORY": "Quelle est la sous-gamme du produit ?"
    },
    "LABEL": {
      "PRODUCT": "Sélectionnez le produit",
      "PRODUCT_POPULAR": "Produits les plus populaires",
      "UNSELECTABLE": "À ce jour, ce produit ne peut être réparé par le fabricant.",
      "NO_REPARABLE": "Non réparable"
    },
    "BUTTON": {
      "ADD_PRODUCT": "Demander l'ajout",
      "ADD_PRODUCT_QUESTION": "Vous ne trouvez pas votre produit ?"
    },
    "ASBESTOS_MODAL": {
      "TITLE": "Le produit a-t-il été exposé à l'amiante?",
      "MESSAGE": "Une produit ayant été exposé à l'amiante présente un risque. Une décontamination est nécessaire pour faire réparer un produit. Si le produit n'a pas été décontaminé, le distributeur se trouve dans l'interdiction de renvoyer le produit.",
      "MESSAGE_TWO": "Si le produit a été décontaminé, télécharger le certificat (vous avez la possiblilté de l'ajouter à la fin de la création de dossier)",
      "PLACEHOLDER": "Certificat amiante"
    },
    "STORE_MODAL": {
      "TITLE": "Sélection du magasin",
      "MESSAGE": "Sélectionnez le magasin concerné pour démarrer un dossier",
      "MESSAGE_EXPORT": "Sélectionnez le magasin concerné pour l'export des dossiers",
      "PLACEHOLDER": "Magasin"
    }
  },
  "STEPPER": {
    "TITLE": "Dossier en création",
    "ARIA_LABEL": "Étapes de création du dossier de réparation",
    "LOAD_ERROR": "Impossible de charger ce dossier de réparation.",
    "RETRY": "Réessayer",
    "SUMMARY": {
      "NO_FOLDER": "Aucun dossier créé",
      "NO_PRODUCT": "Sélectionnez un produit pour créer le brouillon du dossier."
    },
    "SUBTITLE": {
      "PRODUCT": "Sélectionnez le produit en panne concerné",
      "BREAKDOWN": "Décrivez le motif de la panne",
      "GUARANTEE": "Évaluez la prise en charge garantie",
      "PRICING": "Sélectionnez la tarification adaptée",
      "CLIENT_INFORMATION": "Renseignez les informations client",
      "STORE_INFORMATION": "Renseignez les informations internes du magasin",
      "FILE_INFORMATION": "Renseignez les informations du dossier",
      "TRANSPORT": "Configurez le transport"
    },
    "STEP": {
      "ONE": "Produit",
      "TWO": "Motif de la panne",
      "THREE": "Évaluation de garantie",
      "FOUR": "Tarification",
      "FIVE": "Information client",
      "FIVE_PROSPECT": "Information interne magasin",
      "SIX": "Information interne magasin",
      "SIX_PROSPECT": "Information dossier",
      "SEVEN": "Transport"
    }
  },
  "ASK_PRODUCT_CREATION": {
    "MESSAGE": "Ajoutez les informations visibles sur la plaque signalétique. Réponse sous 8 à 24h.",
    "DROPZONE_TITLE": "Déposez la photo de la plaque signalétique",
    "ACCEPTED_FORMATS": "Formats acceptés : JPG, JPEG, PNG",
    "NAMEPLATE_HINT": "Photo de la plaque signalétique. Si elle est absente, ajoutez une photo du produit complet.",
    "TAKE_PHOTO": "Prendre une photo",
    "QR_UPLOADED": "Photo ajoutée via QR code.",
    "QR_VALIDATION_ERROR": "Aucune photo n'a encore été ajoutée via QR code.",
    "LABEL": {
      "EMAIL": "Email de contact",
      "MANUFACTURER": "Marque",
      "PRODUCT_NAME": "Nom du produit",
      "PRODUCT_CODE": "Code / référence produit",
      "SENDER_NAME": "Nom de l'entreprise de votre client (pour resaisir le dossier ultérieurement)",
      "NAMEPLATE": "Plaque signalétique",
      "NAMEPLATE_UPLOADED_VIA_QR": "Photo envoyée via QR code",
      "INPUT_LABEL_BY_QR_CODE": "Envoyer via QR code",
      "INPUT_LABEL_BY_PC": "Envoyer depuis l'ordinateur",
      "NAMEPLATE_VALIDATION_CHECKBOX": "Je confirme avoir ajouté la photo via QR code",
      "UNDER_GUARANTEE": "Produit sous garantie"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez le produit"
    },
    "BUTTON": {
      "UPLOAD_WITH_QR_CODE": "Ajouter via QR code"
    },
    "SUBMIT": "Envoyer la demande (réponse sous 8-24h)",
    "SUCCESS": "Votre demande de création de produit a été envoyée.",
    "TITLE": "Demander la création d'un produit",
    "QR_MODAL": {
      "TITLE": "Envoyer une photo depuis votre téléphone",
      "MESSAGE": "Scannez ce QR code pour prendre en photo la plaque signalétique. Cochez la case une fois cette étape validée.",
      "WARNING": "Ne fermez pas cette fenêtre, vous devez valider le formulaire une fois la photo envoyée, sinon votre demande ne pourra pas être prise en compte",
      "CLOSE": "Fermer"
    },
    "QR_PAGE": {
      "TITLE": "Ajouter une photo",
      "SUBTITLE": "Ajoutez la photo de la plaque signalétique depuis votre téléphone.",
      "DROPZONE_TITLE": "Déposez la photo",
      "ACCEPTED_FORMATS": "JPG, JPEG, PNG",
      "HINT": "Photo de la plaque signalétique. Si elle est absente, ajoutez une photo du produit complet.",
      "TAKE_PHOTO": "Prendre une photo",
      "REMOVE_FILE": "Supprimer la photo",
      "SUBMIT": "Envoyer la photo",
      "TITLE_SENT": "Photo envoyée",
      "MESSAGE_SENT": "Vous pouvez retourner sur votre ordinateur pour finaliser la demande.",
      "TITLE_ERROR_TOKEN_VALIDITY": "Lien expiré ou invalide",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Veuillez générer un nouveau QR code depuis la demande."
    }
  },
  "REPAIR_FILE_RECAP": {
    "STEP_ONE": {
      "TITLE": "Produit sélectionné",
      "MANUFACTURER": "Marque",
      "CATEGORY": "Gamme",
      "SUB_CATEGORY": "Sous-gamme",
      "PRODUCT": "Produit",
      "SERIAL_NUMBER": "N° série",
      "QUESTION": "Questionnaire électroportatif"
    },
    "STEP_TWO": {
      "TITLE": "Motif de la panne",
      "BREAKDOWN": "Description de la panne",
      "TYPE": "Éléments en panne"
    },
    "STEP_THREE": {
      "TITLE": "Prise en charge",
      "GUARANTEE": {
        "TITLE": "Prise en charge",
        "UNDER_GUARANTEE": "Sous garantie",
        "OUT_GUARANTEE": "Hors garantie"
      }
    },
    "STEP_FOUR": {
      "TITLE": "Tarification",
      "PACKAGE": "Forfait",
      "ESTIMATE": "Devis",
      "CUSTOMER_CODE": "Client / Prospect",
      "AMOUNT": "Montant",
      "DELAY": "Délai moyen",
      "DAYS": "{count} jours",
      "ASK_ESTIMATE": "Demander un devis de réparation",
      "TOOLTIP": {
        "HEADER": "Vous ne pouvez pas réparer ?\n Recyclez !",
        "CONTENT": "Profitez de notre aide au recyclage pour vous séparer de votre matériel."
      }
    },
    "STEP_FIVE": {
      "TITLE": "Information client",
      "COMPANY": "Entreprise",
      "NAME": "Nom / prénom",
      "CONTACT": "Contact"
    },
    "STEP_SIX": {
      "TITLE": "Information interne du magasin",
      "INTERNAL_COMMAND_NUMBER": "Numéro de commande fournisseur"
    }
  },
  "FILE_STEP_BREAKDOWN": {
    "TITLE": "Décrivez la panne",
    "DESCRIPTION": "Quel problème rencontrez-vous ?",
    "PRODUCT_BREAKDOWN": "Type de panne",
    "LOAD_ERROR": "Les informations de panne n'ont pas pu être chargées.",
    "PLACEHOLDER": {
      "DESCRIPTION": "Décrivez brièvement le dysfonctionnement observé",
      "PRODUCT_BREAKDOWN": "Sélectionnez le type de panne"
    },
    "PRODUCT_QUESTION_MODAL": {
      "TITLE": "Questions - {breakdown}",
      "MESSAGE": "Répondez aux questions associées au type de panne sélectionné."
    },
    "DIALOG": {
      "TITLE": "Problème avec",
      "CONTENT": "Avant de déclencher une réparation, soyez persuadé que cet accessoire n'est pas la cause de la panne. Dans le cas où la réparation serait demandé et que l'accessoire sera incriminé, le fabricant vous facturera les couts de transports et ne réparera pas le produit."
    },
    "BUTTON": {
      "NOT_FOUND_BREAKDOWN": "Je ne trouve pas le type de panne"
    },
    "STEP_TWO": {
      "TITLE": "Produit",
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :"
    }
  },
  "FILE_STEP_GUARANTEE": {
    "TITLE": "Évaluation de garantie",
    "SUB_TITLE": "Recherchez le numéro de série",
    "SERIAL_PREREQUISITE": "Renseignez un numéro de série valide pour poursuivre l'évaluation de garantie.",
    "PURCHASE_EMPTY": "Renseignez une date d'achat pour calculer la couverture.",
    "EXTENSION_EMPTY": "Renseignez une date d'extension pour calculer la couverture.",
    "DISTRIBUTOR_REF": "Références produit distributeur",
    "WARNING_TITLE": "Hors garantie",
    "SUCCESS_TITLE": "Sous garantie",
    "GUARANTEE_TIME": "Durée de garantie",
    "PROOF_EXTENSION_GUARANTEE": "Justificatif d'extension de garantie",
    "PROOF_PURCHASE_DATE": "Justificatif de date d'achat",
    "GUARANTEE_TIME_REMAINING": "Temps restant",
    "DATE": "Date d'achat",
    "DAYS": "jours",
    "DAY": "jour",
    "NO_DAY": "0 jour",
    "TODAY": "Aujourd'hui",
    "END_DATE_EXTENSION_GUARANTEE": "Date de fin d'extension de garantie",
    "LOAD_ERROR": "Les informations de garantie n'ont pas pu être chargées.",
    "SERIAL_LOOKUP_ERROR": "La couverture de garantie n'a pas pu être vérifiée.",
    "RETRY": "Réessayer",
    "INVALID_DURATION": "La durée de garantie configurée est invalide.",
    "NAMEPLATE_ALT": "Plaque signalétique du produit",
    "PROOF_UPLOADED": "Document ajouté",
    "REMOVE_PROOF": "Supprimer le document",
    "UPLOAD_DESKTOP": "Depuis l'ordinateur",
    "UPLOAD_MOBILE": "Via mobile",
    "QR_TITLE": "Ajouter le document via mobile",
    "QR_HELP": "Scannez ce QR code avec un mobile, ajoutez le document, puis confirmez ici une fois l'envoi terminé.",
    "QR_CONFIRM": "Confirmer l'envoi",
    "QR_TOKEN_ERROR": "Le lien d'ajout mobile n'a pas pu être généré.",
    "QR_MISSING_UPLOAD": "Aucun document reçu pour le moment. Envoyez le document depuis le mobile puis réessayez.",
    "PLACEHOLDER": {
      "SEARCH": "Numéro de série"
    },
    "BUTTON": {
      "ENFORCE_SUPPORT": "Forcer la prise en charge",
      "UNKNOWN_DATE": "Je ne trouve pas la date d'achat",
      "CONTINUE": "Valider la prise en charge",
      "WITHOUT_EXTENSION": "Sans extension"
    },
    "TEXT": {
      "SERIAL_NUMBER_EXAMPLE_ONE": "Le numéro de série se trouve généralement sur la plaque signalétique du produit.",
      "SERIAL_NUMBER_EXAMPLE_TWO": "Saisissez le numéro de série complet pour poursuivre l'évaluation de garantie."
    },
    "FORCE_GUARANTEE_MODAL": {
      "TITLE": "Forcer la prise en charge sous garantie",
      "MESSAGE": "Le système indique une prise en charge théorique mais le distributeur a tout à fait la possibilité de forcer la prise en charge sous garantie. Il vous faut expliquer clairement la raison au fabricant / réparateur afin qu’il puisse décider si la prise en charge est pertinente.",
      "SUB_TITLE_ONE": "Pourquoi la prise en charge devrait être sous garantie ?",
      "SUB_TITLE_TWO": "Justificatif de prise en charge forcée",
      "PLACEHOLDER": {
        "SUB_GUARANTEE": "Exemple : cette machine fut réparée chez le fabricant il y a 3 mois et est donc sous garantie.",
        "FILE": "Garantie, Facture de Réparation"
      },
      "BUTTON": "Valider le motif"
    },
    "EXCLUSION_GUARANTEE_MODAL": {
      "TITLE": "Exclusions de la prise en charge sur ce produit",
      "BUTTON": {
        "VALID": "Valider l'évaluation"
      }
    },
    "ERROR": {
      "SERIAL_NUMBER_NOT_FOUND_FOR_EXTENSION": "Numéro de série inconnu pour l'extension de garantie",
      "SERIAL_NUMBER_NOT_FOUND_FOR_PROLONGATION": "Numéro de série inconnu pour la prolongation de garantie",
      "SERIAL_NUMBER_NOT_GOOD_FORMAT": "Le numéro de série doit contenir {value} caractère(s).",
      "SERIAL_NUMBER_NOT_UNKNOWN": "Aucun modèle de numéro de série pour ce produit"
    }
  },
  "FILE_STEP_PRICING": {
    "FORCE_ESTIMATE": {
      "TITLE": "Devis",
      "DESCRIPTION": "Uniquement pour réparations en magasin / réparateur indépendant",
      "VALIDATE": "Déclencher demande de DEVIS - Hors Constructeur"
    },
    "TITLE": "Tarification",
    "LOAD_ERROR": "Les informations de tarification n'ont pas pu être chargées.",
    "FREE_SUPPORT": "Gratuit",
    "GUARANTEE_COVERAGE": "Prise en charge sous garantie",
    "CUSTOMER_CODE": "Consultez les codes et ajustez votre forfait ci-dessous si besoin",
    "RETURN_CLIENT_TRANSPORT_COST": "Je souhaite intégrer le cout du transport CHRONOPOST RETOUR après SAV, entre mon magasin et chez mon client. Cette option de Transport est disponible à l'étape RECEPTION MAGASIN.",
    "PLACEHOLDER": {
      "CUSTOMER_CODE": "Code"
    },
    "TOOLTIP": {
      "S_1": "Augmenter le forfait :",
      "T_1": "ajouter P8 jusqu’à P50 ; le chiffre représente le montant de la hausse (P50 = +50€)",
      "S_2": "Diminuer le forfait :",
      "T_2": "ajouter M8 jusqu’à M50 ; le chiffre représente le montant de la remise (M8 = -8€)",
      "S_3": "Recyclage :",
      "T_3": "indiquer le code de reprise visible sur votre certificat de cession"
    },
    "PACKAGE_INFO": {
      "PACKAGE": "Forfait",
      "ESTIMATE": "Demander un devis de réparation",
      "REPAIR_TIME": "Délai moyen de réparation constaté",
      "REPAIR_COST": "Forfait de réparation",
      "TRANSPORT_COST": "Frais de transport",
      "ESTIMATE_TRANSPORT_COST": "Coût de transport estimatif pour le transport aller",
      "ADDITIONAL_COST": "Frais de gestion",
      "REPAIR_FUND": "Fond de réparation",
      "REPAIR_AMOUNT": "Montant réparation",
      "WITH_DIAGNOSTIC": "selon diagnostic",
      "DIAGNOSTIC_COST": "Frais de diagnostic par réparateur (si refus)",
      "CLIENT_PRICE_TOOLTIP": {
        "PACKAGE": "Forfait : {networkCode}\n+ coût facturé par le fabricant au magasin\n= {amount} {euro}",
        "ESTIMATE": "Coût estimatif de la réparation à payer par le magasin = {amount} {euro}. (En attente du devis réel du fabricant).\n *Le client s'engage à payer le prix global affiché quelque soit le montant du devis."
      },
      "DAYS": "jours",
      "NOT_PROVIDED": "Non renseigné",
      "ESTIMATE_PACKAGE": "Envoyer le devis du forfait",
      "PRODUCT_NEW_PRICE": "Prix de vente indicatif/public"
    },
    "MODAL": {
      "PACKAGE_ESTIMATE": {
        "TITLE": "Devis du forfait",
        "SUB_TITLE": "Envoyer la demande de devis forfait à :",
        "FILE_INPUT": {
          "PACKAGE": "Fiche SAV Client"
        },
        "LABEL": {
          "COMMENT": "Informations complémentaires",
          "COMPANY_NAME": "Nom de l'entreprise",
          "CUSTOMER_NAME": "Nom du client",
          "EMAIL_CONTACT": "Adresse mail de contact",
          "PHONE_NUMBER": "Numéro de téléphone"
        },
        "MOBILE_NUMBER_HINT": "Attention ce numéro ne vous permettra pas d'envoyer un SMS à votre client, pour l'informer de la disponibilité du produit - Mettre un 06 ou 07",
        "PLACEHOLDER": {
          "COMMENT": "Ex : Proposition d'un produit neuf à 245€"
        },
        "VALIDATION_BUTTON": "Envoyer",
        "BOTTOM_TEXT": "Une fois le devis du forfait envoyé au client, le dossier sera sauvegardé et modifiable",
        "MESSAGE": {
          "VALIDATION": "Un email a été transmis avec succès à votre client avec le devis du forfait"
        }
      }
    }
  },
  "FILE_STEP_CREATE_FOLDER": {
    "TITLE": "Information client",
    "SUBTITLE": "Vérifiez les coordonnées utilisées pour créer le dossier.",
    "SUB_TITLE": {
      "GENERAL_INFORMATION": "Information du contact Entreprise pour la gestion de ce SAV",
      "ATTACHMENT": "Pièce à joindre avec le dossier"
    },
    "FORM": {
      "ERP_MODE": "Création automatique sur ITECH",
      "NAME": "Nom du contact",
      "COMPANY": "Entreprise",
      "MAIL": "Adresse e-mail",
      "PHONE": "Téléphone",
      "WORKSITE_CODE": "Code chantier / Code imputation / Code interne",
      "COMPANY_SELECTOR": "Sélectionner l’entreprise dans la liste déroulante",
      "KEY_ACCOUNT_CLIENT": "Ce client est un Grand Compte",
      "OPERATING_CENTER": "Centre d'exploitation"
    },
    "PLACEHOLDER": {
      "NAME": "Nom du contact",
      "COMPANY": "Nom de l'entreprise",
      "MAIL": "Adresse e-mail",
      "PHONE": "Numéro de téléphone",
      "WORKSITE_CODE": "Code chantier / imputation / interne",
      "COMPANY_SELECTOR": "Sélectionnez une entreprise",
      "OPERATING_CENTER": "Sélectionnez un centre d'exploitation"
    },
    "HELP_TEXT": {
      "DISABLE_ERP": "Si votre client n'a pas de compte ITECH, déselectionnez le bouton \"Création automatique sur ITECH\"",
      "RGPD_RULES": "RGPD : Une fois le dossier clôturé, les données personnelles renseignées ci-dessus seront automatiquement supprimées"
    },
    "FILE_INPUT": {
      "BILLING": "Facture client",
      "EXTENSION_GUARANTEE": "Extension de garantie",
      "ASBESTOS_SHEET": "Déclaration amiante",
      "FORCE_GUARANTEE": "Pièce justificative forcer la prise en charge",
      "DEFAULT": "File supported: pdf, jpg, png",
      "DEFAULT_WARNING": "Pièce manquante à fournir",
      "DEFAULT_WARNING_ASBESTOS": "Pièce optionnel manquante"
    },
    "MODAL": {
      "TITLE": {
        "BILLING": "Justificatif de date d'achat",
        "EXTENSION_GUARANTEE": "Justificatif de date d'extension garantie",
        "ASBESTOS_SHEET": "Certificat amiante",
        "FORCE_GUARANTEE": "Justificatif pour forcer la prise en charge"
      },
      "BUTTON": {
        "VALIDATE": "Envoyer"
      }
    },
    "SUBMIT": "OPTION 1 : Toutes marques, je ne connais pas le process; Je fais une demande de prise en charge auprès du fabricant",
    "EXPERT_MODE": "OPTION 2 : Uniquement pour PRAMAC, RUBI, ABAC et LECIA ... Process EXPERT, je connais et sélectionne directement le réparateur"
  },
  "FILE_STEP_STORE_INTERNAL": {
    "TITLE": "Information interne du magasin",
    "FORM": {
      "INTERNAL_COMMAND_NUMBER": "Numéro de commande fournisseur",
      "INTERNAL_COMMAND_NUMBER_HINT": "Si vous souhaitez modifier le N° de commande fournisseur : utilisez 10 caractères MAXIMUM, uniquement des MAJUSCULES et SANS ESPACE. La bonne coordination avec les réparateurs est essentielle : tout écart rendra le suivi plus complexe"
    },
    "PLACEHOLDER": {
      "INTERNAL_COMMAND_NUMBER": "Saisissez le numéro de commande fournisseur"
    }
  },
  "FILE_STEP_TRANSPORT_MODALITY": {
    "UI": {
      "ADDRESS_SUBTITLE": "Sélectionnez une modalité de transport et confirmez les adresses de départ et de retour.",
      "TRANSPORT_SUBTITLE": "Sélectionnez le matériel et une option de transport.",
      "MATERIAL_SUBTITLE": "Sélectionnez les éléments présents dans votre colis. Ajustez les quantités si nécessaire.",
      "CHOICE_TITLE": "Choisissez le transporteur",
      "CHOICE_SUBTITLE": "Les options disponibles dépendent du matériel déclaré et des dimensions du colis.",
      "PACKAGE": "Détails du colis (calcul automatique)",
      "BATTERY": "Batterie",
      "PALLET": "Palette",
      "SPECIFIC_TRANSPORT": "Transport spécifique (messagerie)",
      "OWN_TRANSPORT": "Organiser le transport par vos propres moyens",
      "CONFIRM_INFORMATION": "Confirmer les informations",
      "EDIT_ADDRESS": "Modifier l'adresse",
      "ADDRESS_FLOW": {
        "DEPARTURE": "Départ",
        "REPAIR": "Réparation",
        "RETURN": "Retour"
      },
      "LOAD_ERROR": "Impossible de charger les informations de transport.",
      "INIT_ERROR": {
        "ELIGIBILITY": "Impossible de charger les paramètres d'éligibilité au transport du magasin. Réessayez ou contactez l'assistance si le problème persiste.",
        "MANUFACTURERS": "Impossible de charger les marques couvertes par les paramètres de prise en charge du transport du magasin. Réessayez ou contactez l'assistance si le problème persiste.",
        "ALTERNATIVES": "Impossible de charger les réparateurs alternatifs disponibles pour ce dossier. Réessayez ou contactez l'assistance si le problème persiste.",
        "PRODUCTS": "Impossible de charger le produit et le matériel à transporter. Réessayez ou contactez l'assistance si le problème persiste.",
        "STATE": "Impossible de restaurer le formulaire de transport à partir du dossier et du magasin sélectionné. Réessayez ou contactez l'assistance si le problème persiste."
      },
      "INIT_DIAGNOSTIC": {
        "SOURCES": {
          "ELIGIBILITY": "Échec de la lecture des paramètres de prise en charge du transport du magasin",
          "MILWAUKEE_MANUFACTURERS": "Échec du chargement des marques prises en charge par le transport Milwaukee",
          "GUARANTEE_MANUFACTURERS": "Échec du chargement des marques prises en charge sous garantie pour le magasin",
          "WITHOUT_GUARANTEE_MANUFACTURERS": "Échec du chargement des marques prises en charge hors garantie pour le magasin",
          "ALTERNATIVES": "Échec de la recherche des réparateurs alternatifs du magasin",
          "PRODUCTS": "Échec du chargement du produit sélectionné et du matériel associé",
          "STATE": "Échec de la restauration du formulaire de transport"
        },
        "FIELDS": {
          "repairFile": "Dossier",
          "store": "Magasin",
          "network": "Réseau",
          "manufacturer": "Marque",
          "product": "Produit",
          "warranty": "Garantie"
        },
        "CAUSES": {
          "SESSION": "Votre session n'est plus valide. Reconnectez-vous.",
          "ACCESS": "L'accès à ces informations a été refusé. Demandez à votre administrateur de vérifier vos droits.",
          "TIMEOUT": "Le service n'a pas répondu à temps. Réessayez ; cela ne permet pas de conclure à un problème de configuration.",
          "NETWORK": "L'application n'a pas pu joindre le service. Vérifiez votre connexion et réessayez.",
          "SERVICE": "Le service n'a pas pu traiter cette demande. La réponse ne précise pas de configuration manquante.",
          "NOT_FOUND": "Les informations demandées sont introuvables. Vérifiez les références indiquées ci-dessus.",
          "INVALID_DATA": "Les informations reçues n'ont pas pu être lues ou restaurées. Transmettez les références ci-dessus à l'assistance.",
          "UNKNOWN": "La réponse ne permet pas de déterminer la cause. Transmettez ce diagnostic à l'assistance."
        },
        "CHECKS": {
          "ELIGIBILITY": "À vérifier : les paramètres de prise en charge du transport du magasin (Milwaukee, sous garantie et hors garantie). S'ils sont corrects, demandez à l'assistance de vérifier leur chargement.",
          "MILWAUKEE_MANUFACTURERS": "À vérifier : la liste des marques prises en charge pour le transport Milwaukee. Si elle est correcte, demandez à l'assistance de vérifier son chargement.",
          "GUARANTEE_MANUFACTURERS": "À vérifier : la liste des marques prises en charge sous garantie pour le transport du magasin. Si elle est correcte, demandez à l'assistance de vérifier son chargement.",
          "WITHOUT_GUARANTEE_MANUFACTURERS": "À vérifier : la liste des marques prises en charge hors garantie pour le transport du magasin. Si elle est correcte, demandez à l'assistance de vérifier son chargement.",
          "ALTERNATIVES": "À vérifier : l'activation des réparateurs alternatifs du magasin et les réparateurs associés, puis leurs configurations dans ce réseau et leur couverture de garantie. Ces configurations n'exigent pas de correspondance sur la marque, la gamme ou la sous-gamme.",
          "PRODUCTS": "À vérifier : la référence du produit sélectionné, sa disponibilité pour ce réseau et ce magasin, et le matériel associé. Si ces données sont correctes, demandez à l'assistance de vérifier le chargement de la liste des produits.",
          "STATE": "À vérifier : le magasin sélectionné et les données de transport enregistrées dans le dossier (modalité, adresses et produits sélectionnés). Demandez à l'assistance de vérifier la restauration ; ne supprimez pas le dossier."
        },
        "ALTERNATIVES": {
          "STORE_MISSING": "Le magasin du dossier est introuvable.",
          "DISABLED": "Les réparateurs alternatifs ne sont pas activés pour ce magasin.",
          "NO_REPAIRERS": "Aucun réparateur alternatif n'est associé à ce magasin.",
          "NO_NETWORK_CONFIGURATION": "Aucune configuration de réparateur n'existe dans le réseau autorisé.",
          "NO_MATCH": "Aucune configuration de ce réseau ne correspond à un réparateur alternatif associé au magasin avec la couverture de garantie requise.",
          "ENABLE": "Aucune condition de magasin ou de garantie ne manque sur cette configuration ; vérifiez l'activation des réparateurs alternatifs pour le magasin."
        },
        "CONDITIONS": {
          "store": "réparateur associé comme alternatif à ce magasin",
          "warranty": "couverture de garantie requise"
        },
        "REFERENCE": "Référence pour l'assistance : {reference}"
      },
      "CONTEXT_ERROR": "Impossible de charger la configuration du réparateur.",
      "ROUTING_DIAGNOSTIC": {
        "TITLE": "Aucune configuration de réparateur officiel ne correspond à ce dossier.",
        "FIELDS": {
          "manufacturer": "Constructeur",
          "category": "Catégorie",
          "subcategory": "Sous-catégorie",
          "store": "Magasin",
          "warranty": "Prise en charge de la garantie"
        },
        "WARRANTY": {
          "without_guarantee": "Hors garantie",
          "guarantee": "Sous garantie"
        },
        "CANDIDATES": "Configurations les plus proches dans votre réseau (à confirmer par un administrateur) :",
        "MISSING": "conditions non satisfaites : {conditions}.",
        "LIMIT": "Seules les 5 premières configurations parmi {count} correspondances proches sont affichées.",
        "NO_CANDIDATES": "Aucune configuration liée à ce constructeur, cette catégorie ou cette sous-catégorie n'a été trouvée dans votre réseau.",
        "NO_CONFIGURATION": "Aucune configuration de réparateur n'existe pour votre réseau.",
        "ACTION": "Un administrateur doit confirmer le réparateur prévu et corriger les associations ou la prise en charge de la garantie dans sa configuration. Une seule configuration doit satisfaire toutes les conditions ci-dessus. Aucun réparateur n'a été sélectionné automatiquement."
      },
      "CARRIER_ERROR": "Impossible de charger les transporteurs disponibles.",
      "ADD_MATERIAL": "Ajouter : {name}",
      "REMOVE_MATERIAL": "Retirer : {name}"
    },
    "TEMPORARY_MESSAGE": {
      "CONFIRMATION_BUTTON": "J'ai compris"
    },
    "TITLE": "Transport",
    "SUB_TITLE": {
      "ADDRESS_INFORMATION": "Informations sur les adresses",
      "TRANSPORTER_INFORMATION": "Choix du transport"
    },
    "SELECT": {
      "MODALITY_TYPE": {
        "TITLE": "Modalité de transport",
        "TRANSPORTER": "Envoi au constructeur/réparateur officiel",
        "IMPOSSIBLE_ERP_WARNING": "Pour faire réparer ce produit chez cet industriel, votre magasin doit posséder un N° DE COMPTE ACTIF avec ce réparateur.\n Pour identifier un réparateur alternatif, contacter l'équipe BOOMERANG support{'@'}boomerang-exploration.com",
        "ALTERNATIVE_TRANSPORTER": "Envoi à votre réparateur local (uniquement si VOUS SAVEZ qu'il répare cette marque)",
        "ALTERNATIVE_TRANSPORTER_TITLE": "Sélectionnez un réparateur local",
        "WORKSHOP": "Dépôt en main propre au réparateur",
        "STORE": "Réparation / Gestion par le magasin",
        "EXCLUDING_SUPPORT": "Hors process"
      },
      "ADDRESS": {
        "TITLE": "Renseignez les adresses"
      }
    },
    "CARD_STEP_ONE": {
      "TITLE": {
        "SEND_FROM": "Adresse de départ",
        "SEND_TO": "Réparateur",
        "RECEIVE_TO": "Adresse de retour"
      },
      "NAME": "Nom de l’adresse",
      "ADDRESS": "Adresse",
      "COMPLEMENT_ONE": "Complément d'adresse",
      "ZIP_CODE": "CP Ville",
      "CONTACT_NAME": "Nom du contact",
      "CONTACT_EMAIL": "Email",
      "CONTACT_PHONE": "Téléphone"
    },
    "CARD_STEP_TWO": {
      "BATTERY": "Batterie de ",
      "WATT_HOUR": "Wh",
      "EXPRESS": "Messagerie Obligatoire"
    },
    "CARD_TRANSPORTER": {
      "TITLE": "Enlèvement et suivi {transporter}",
      "TITLE_WHITE_LIST": "Indisponible",
      "TYPE": "Expressiste",
      "OPERATOR_MARKET": "Opéré par le magasin",
      "NO_TRANSPORTER": "Aucun transporteur trouvé"
    },
    "CARD_CUSTOMER_SERVICE": {
      "TYPE": "Utilisez cette option lorsque Chronopost ne peut pas prendre en charge l’envoi, notamment en raison de dimensions hors normes.",
      "TYPE_BOOMERANG": "Le fabricant exige un process spécifique. Cliquer sur cette option pour que votre équipe SIEGE ou PARTENAIRE s'en charge et vous partage l'étiquette transport adéquate."
    },
    "CARD_WITHOUT_TRANSPORTER": {
      "TYPE": "Sans suivi logistique par l’équipe Boomerang."
    },
    "CHRONOPOST_CONFIRMATION": {
      "CARD_NOTICE": "Respectez les conditions ci-dessous",
      "TITLE": "JE CONFIRME que le CARTON/COLIS ne dépasse pas ces 4 CONDITIONS :",
      "LINE_1": "1. Le colis ne dépasse pas {maxLength} de long",
      "LINE_2": "2. Le calcul du développé ne dépasse pas 300 cm. Développé = Largeur + 2 × Longueur + 2 × Hauteur",
      "LINE_3": "3. Le colis est INFÉRIEUR à {maxWeight}",
      "LINE_4": "4. Le produit n'est pas sur PALETTE"
    },
    "SELECT_MATERIAL": {
      "TITLE": "Matériel à déclarer",
      "WEIGHT": "Poids",
      "BIGGEST_WIDTH": "Largeur (cm)",
      "BIGGEST_LENGTH": "Longueur (cm)",
      "KILOGRAM": "kg",
      "CENTIMETER": "cm"
    },
    "PLACEHOLDER": {
      "MODALITY_TYPE": "Sélectionnez une modalité",
      "ALTERNATIVE_REPAIRER": "Réparateur(s) alternatif(s)"
    },
    "BUTTON": {
      "NEXT": "Prochaine étape",
      "VALIDATION": "Programmer l’expédition"
    },
    "MODAL": {
      "ADDRESS": {
        "TITLE": {
          "SEND_FROM": "Modifier l'adresse de départ",
          "SEND_TO": "Adresse du réparateur",
          "RECEIVE_TO": "Modifier l'adresse de retour"
        },
        "NAME": "Nom de l’adresse",
        "NUMBER": "N°",
        "STREET": "Rue",
        "COMPLEMENT_ONE": "Complément d'adresse",
        "ZIP_CODE": "Code postal",
        "CITY": "Ville",
        "CONTACT_NAME": "Nom du contact",
        "CONTACT_EMAIL": "Email",
        "CONTACT_PHONE": "Téléphone",
        "VALIDATION_BUTTON": "Enregistrer l'adresse"
      },
      "BATTERY": {
        "TITLE": "Caractéristiques de la batterie",
        "MESSAGE": "Une batterie au lithium endommagée peut court-circuiter pendant le transport et provoquer une surchauffe ou un incendie.\n\nL'expéditeur est responsable du transport et des coûts qui en résultent en cas d'accident. Les marchandises dangereuses doivent être correctement déclarées, emballées et étiquetées, et accompagnées des documents requis.\n\nLes batteries d'une capacité de 100 Wh ou plus ne sont pas acceptées par les transporteurs express (TNT, Chronopost ou UPS). Elles doivent être expédiées par messagerie et déclarées et étiquetées en conséquence. L'étiquette est disponible à la fin de cette procédure.",
        "TEXT_INPUT": {
          "VOLTAGE": "Tension de la batterie",
          "AMPERAGE": "Intensité de la batterie",
          "CHECKBOX": "Cas particuliers :\nDEWALT : je confirme avoir installé le capot requis sur la batterie FLEXVOLT afin qu'elle puisse être expédiée par transport express.\nFESTOOL : je confirme avoir placé la POWERSTATION sur OFF afin qu'elle puisse être expédiée par transport express."
        },
        "EXPRESS": {
          "YES": "Transport express autorisé",
          "NO": "Transport par messagerie obligatoire"
        },
        "PLACEHOLDER": {
          "VOLTAGE": "18 V",
          "AMPERAGE": "8 Ah"
        }
      },
      "MANUFACTURER_TRANSPORTER": {
        "TITLE": "Demande d’un transport auprès du service client du réparateur",
        "SUB_TITLE": "Envoyer la demande d’un transporteur au réparateur par email:",
        "FILE_INPUT": {
          "ORDER": "Ordre de réparation",
          "PACKAGE": "Fiche SAV client"
        },
        "INFORMATION": {
          "TITLE": "Information complémentaires",
          "NUMBER": "Contact du service client du réparateur",
          "ERP_REPAIRER_NUMBER": "Votre numéro client",
          "INTERNAL_COMMAND_NUMBER": "Votre numéro de commande"
        },
        "VALIDATION_BUTTON": "Envoyer et finaliser le dossier",
        "BOTTOM_TEXT": "Suite à cette demande, le dossier sera sauvegardé dans l’attente de l’étiquette “TRANSPORT”",
        "BOTTOM_TEXT_PARTNER": "Votre demande va être traitée par votre partenaire qui vous enverra les étiquettes transports rapidement.",
        "BOTTOM_TEXT_ALERT_PREFIX": "Si pas de nouvelles",
        "BOTTOM_TEXT_ALERT_SUFFIX": "sous 48h, contacter l'équipe",
        "BOTTOM_TEXT_ALERT_TEAM": "BOOMERANG",
        "MESSAGE": "Email envoyé avec succès"
      }
    }
  },
  "CUSTOMER_SERVICE_TRANSPORT_PAGE": {
    "STEPS": {
      "STEP1": {
        "TITLE": "Lieu et coordonnées d'enlèvement",
        "SUBTITLE": "Sélectionnez le lieu et vérifiez le contact et l'adresse."
      },
      "STEP2": {
        "TITLE": "Informations colis",
        "SUBTITLE": "Vérifiez les dimensions et le conditionnement du colis."
      },
      "STEP3": {
        "TITLE": "Disponibilités d'enlèvement",
        "SUBTITLE": "Indiquez les jours et créneaux disponibles."
      }
    },
    "TITLE": "Demande de transport au service client",
    "SUBTITLE": "Renseignez les informations nécessaires à l'organisation de l'enlèvement",
    "TRANSPORT_SUBTITLE": "Le réparateur utilisera ces informations pour organiser l'enlèvement et vous transmettre les documents de transport.",
    "SUMMARY_TITLE": "Transport organisé par le service client du réparateur",
    "SUMMARY": "Demande de transport en préparation",
    "UNITS": { "CM": "cm" },
    "SUMMARY_SECTIONS": {
      "LOCATION": "Enlèvement",
      "PICKUP_LOCATION": "Lieu",
      "CONTACT": "Contact",
      "ADDRESS": "Adresse",
      "CITY": "Ville",
      "PACKAGE": "Colis",
      "DIMENSIONS": "Dimensions (L x l x H)",
      "COMMENT": "Commentaire"
    },
    "ORDER_TAG": "Nº {number}",
    "LOCATION": {
      "TITLE": "Lieu d'enlèvement",
      "SUBTITLE": "Sélectionnez le lieu",
      "PLACEHOLDER": "Sélectionnez le lieu",
      "CUSTOMER": "Chez le client",
      "SITE": "Au magasin"
    },
    "CONTACT": {
      "TITLE": "Contact et adresse d'enlèvement",
      "SUBTITLE": "Ces informations seront transmises au service client pour organiser le transport",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "EMAIL": "Email",
      "PHONE": "Téléphone",
      "ADDRESS_NAME": "Nom du site",
      "ADDRESS_NUMBER": "N°",
      "ADDRESS_STREET": "Rue",
      "ADDRESS_COMPLEMENT_1": "Complément d'adresse 1",
      "ADDRESS_COMPLEMENT_2": "Complément d'adresse 2",
      "ZIP_CODE": "Code postal",
      "CITY": "Ville",
      "COUNTRY": "Pays"
    },
    "PACKAGE": {
      "TITLE": "Informations colis",
      "SUBTITLE": "Indiquez les dimensions finales du colis ou de la palette",
      "WEIGHT": "Poids (kg)",
      "LENGTH": "Longueur (cm)",
      "WIDTH": "Largeur (cm)",
      "HEIGHT": "Hauteur (cm)",
      "PALLET": "Transport sur palette"
    },
    "COMMENT": {
      "TITLE": "Commentaire de transport",
      "SUBTITLE": "Ajoutez toute information utile pour l'enlèvement",
      "PLACEHOLDER": "Préciser le/les jours de ramasse souhaités, précisions d'instruction pour le chauffeur, emplacement spécifique du produit..."
    },
    "PLANNING": {
      "TITLE": "Disponibilités pour l'enlèvement",
      "SUBTITLE": "Créez, déplacez ou redimensionnez jusqu'à deux créneaux par jour",
      "REMOVE_SLOT": "Supprimer le créneau",
      "DAY": {
        "MONDAY": "Lundi",
        "TUESDAY": "Mardi",
        "WEDNESDAY": "Mercredi",
        "THURSDAY": "Jeudi",
        "FRIDAY": "Vendredi"
      },
      "ERROR": {
        "INVALID_RANGE": "Le créneau horaire est invalide.",
        "OVERLAP": "Les créneaux ne peuvent pas se chevaucher.",
        "MAX_SLOTS": "Deux créneaux maximum sont autorisés par jour.",
        "REQUIRED": "Ajoutez au moins un créneau de disponibilité."
      }
    },
    "RECIPIENT": {
      "TITLE": "Service client destinataire",
      "SUBTITLE": "Vérifiez le destinataire de la demande et téléchargez les documents utiles",
      "EMAIL": "Adresse e-mail du réparateur",
      "PHONE": "Téléphone du service client",
      "ERP_NUMBER": "Votre numéro client chez le réparateur"
    },
    "DOCUMENT": {
      "TITLE": "Documents",
      "PACKAGE": "Fiche du service après-vente client",
      "ORDER": "Ordre de réparation",
      "FILE_NAME": {
        "PACKAGE": "Fiche_SAV_client",
        "ORDER": "Ordre_de_reparation"
      }
    },
    "BUTTON": {
      "BACK": "Retour aux options de transport",
      "SUBMIT": "Envoyer la demande",
      "PREVIOUS": "Étape précédente"
    },
    "MESSAGE": {
      "SUCCESS": "Demande de transport envoyée"
    },
    "ERROR": {
      "LOAD": "Les informations de transport n'ont pas pu être chargées. La demande ne peut pas être envoyée.",
      "CONTACT_NAME": "Renseignez au moins un nom, un prénom ou un nom de site.",
      "POSITIVE_NUMBER": "Saisissez une valeur strictement positive."
    }
  },
  "SHIPPING_PAGE": {
    "PAGE_SUBTITLE": "Préparez et générez l’expédition du dossier de réparation",
    "BACK_TO_TRANSPORT": "Retour aux options de transport",
    "SUMMARY_IN_PROGRESS": "Dossier en cours d'expédition",
    "ADDRESS": "Adresse",
    "CITY": "Ville",
    "WEIGHT": "Poids",
    "LOAD_ERROR": "Impossible de charger les informations d'expédition.",
    "UNSUPPORTED_CARRIER": "Ce transporteur ne permet pas de générer une expédition depuis cette page.",
    "TNT_RECONCILIATION": {
      "TITLE": "Enlèvement accepté par TNT — rapprochement nécessaire",
      "DO_NOT_RESUBMIT": "Ne réservez pas un nouvel enlèvement et ne changez pas de transporteur. TNT a déjà accepté cette demande.",
      "INSTRUCTIONS": "Récupérez la confirmation d'enlèvement et le document de transport auprès de TNT avant de finaliser. Contactez le support Boomerang avec la référence du dossier si un rapprochement est nécessaire. Consulter le dossier enregistré ne crée pas de nouvel enlèvement.",
      "RECEIPT_NOT_SAVED": "La confirmation de réservation n'a pas pu être enregistrée dans Boomerang. Ne renvoyez pas la demande, même après rechargement. Contactez le support Boomerang pour enregistrer l'enlèvement accepté avant de continuer.",
      "REFERENCE": "Référence de l'enlèvement TNT : {reference}",
      "REVIEW": "Consulter le dossier enregistré",
      "NOT_READY": "Le dossier enregistré n'est pas prêt à être finalisé. Contactez le support Boomerang pour rapprocher l'enlèvement accepté. Vous pouvez quitter cette page sans changer de transporteur ni réserver à nouveau."
    },
    "TNT_PREPARATION": {
      "TITLE": "Préparation de l'expédition TNT",
      "SUBTITLE": "Date d'enlèvement et génération de l'étiquette",
      "LOAD_ERROR": "Impossible de charger les options d'enlèvement TNT.",
      "AVAILABLE": "L'enlèvement TNT est disponible à la date indiquée.",
      "CONFIRMATION": "L'enlèvement TNT n'est plus disponible aujourd'hui. Vous pourrez confirmer un enlèvement au prochain jour ouvré ou choisir Chronopost si cette option est disponible.",
      "REFRESH_NOTICE": "La disponibilité de l'enlèvement sera vérifiée à nouveau lors de la génération de l'expédition."
    },
    "TITLE": {
      "SHIPPING": "Expédition"
    },
    "ORDER_TAG": "Nº {number}",
    "TRANSPORTER_SUBTITLE": "Enlèvement express avec étiquette automatique",
    "TRANSPORTER_NAME": {
      "CHRONOPOST": "Chronopost",
      "TNT": "TNT"
    },
    "DEPARTURE": "Départ",
    "UPDATE_DEPARTURE": "Modification de l'adresse de départ",
    "DELIVERY": "Livraison",
    "CHRONOPOST_CONSTRAINTS": "Contraintes Chronopost",
    "CHRONOPOST_PARCEL_CONFIRMATION": "En validant cette étape, vous confirmez que le colis préparé respecte les conditions ci-dessous :",
    "CHRONOPOST_SURCHARGE_WARNING": "Dans le cas contraire, Chronopost facturera un surcoût de +70 € minimum.",
    "COLLECT_TITLE": "Générer une étiquette sans enlèvement",
    "COLLECT_SUBTITLE": "Générez l’étiquette de transport sans programmer d’enlèvement.",
    "EARLY_COLLECT": "Heure d'enlèvement au plus tôt",
    "LAST_COLLECT": "Heure d'enlèvement au plus tard",
    "MAX_CREATION": "Heure limite de création de l'expédition",
    "SHIPPING_DAY": "Date d'enlèvement",
    "WISHED_COLLECT_DATE": "Ramassage souhaité le :",
    "WISHED_DELIVERY_DATE": "Livraison souhaitée le :",
    "DETAIL_SHIPPING": "Détail de votre expédition",
    "MISSING_DATA": "Si les dimensions sont inconnu mettre les champs à 0",
    "LENGTH": "Longueur",
    "WIDTH": "Largeur",
    "HEIGHT": "Hauteur (cm)",
    "PACKAGE": "Colis",
    "SUBTITLE": {
      "CHRONOPOST_CONSTRAINTS": "Date et créneau d'enlèvement",
      "DEPARTURE": "Adresse d'enlèvement",
      "DELIVERY": "Adresse du réparateur",
      "PACKAGE": "Caractéristiques du colis"
    },
    "MESSAGE": {
      "SUCCESS": {
        "FEASIBILITY_MESSAGE": "L'enlèvement Chronopost est disponible.",
        "GENERATE_MESSAGE": "L'expédition Chronopost a été créée.",
        "TNT_GENERATE_MESSAGE": "L'expédition TNT a été créée.",
        "SWITCH_CHRONOPOST": "Transporteur basculé sur Chronopost"
      },
      "ERROR": {
        "MISSING_SERVICE": "Aucun service d'expédition Chronopost n'est disponible.",
        "INVALID_CONSTRAINTS": "Les contraintes Chronopost ne permettent pas de programmer cette expédition.",
        "INVALID_COLLECTION": "La date ou l'heure d'enlèvement n'est plus valide. Actualisez les contraintes et choisissez une autre date d'enlèvement.",
        "CHRONOPOST": "Chronopost n'a pas pu traiter la demande. Réessayez.",
        "HANDLE_UNIT_SHIPPED": "L'unité de manutention est expédiée."
      }
    },
    "BUTTON": {
      "FEASIBILITY": "Vérifier la disponibilité de l'enlèvement",
      "GENERATE_SEND": "Générer l'expédition"
    },
    "TNT_PROGRESS": {
      "TITLE": "Suivi TNT",
      "SUBTITLE": "Progression de la génération de l'étiquette",
      "WAITING": "En attente d'une génération manuelle...",
      "PROCESSING": "Traitement en cours...",
      "LAST_EVENT_LABEL": "Dernier événement",
      "HISTORY_LABEL": "Historique"
    },
    "TNT_PICKUP_OPTIONS": {
      "TITLE": "Enlèvement TNT indisponible aujourd'hui",
      "DESCRIPTION_PREFIX": "La demande TNT sera planifiée au prochain jour ouvré :",
      "DESCRIPTION_SUFFIX": "Choisissez comment continuer.",
      "POSTPONE_TNT": "Décaler la demande d'enlèvement par TNT au prochain jour ouvré",
      "SWITCH_CHRONOPOST": "Basculer sur un enlèvement au plus tôt par Chronopost"
    },
    "PLACEHOLDER": {
      "CHRONOPOST_SERVICE": "Sélectionner votre service chronopost"
    }
  },
  "REPAIR_FILE_FINALIZATION": {
    "TITLE": "Dernières étapes du dossier {internal_command_number}",
    "SUB_TITLE": {
      "SHARE": "1. Partager les informations du dossier avec :",
      "TRACKING_NUMBER": "2. Mémoriser/identifier des éléments liés au transport (Nº dossier/tracking)",
      "PRINT": "3. Imprimer les éléments pour le réparateur"
    },
    "CHECKBOX": {
      "CLIENT_SHARE": "Avec le client :",
      "PREPARER_SHARE": "Avec le préparateur logistique :",
      "COMMERCIAL_SHARE": "Avec équipe commerciale :"
    },
    "PLACEHOLDER": {
      "REPAIRER_SUPPORT_NUMBER": "N° de dossier du réparateur"
    },
    "BUTTON": {
      "REPAIRER_PRINT_1": "Documents pour Réparateur",
      "REPAIRER_PRINT_2": " (ODR/Étiquette Transports)",
      "VALIDATION": "Déclancher le suivi du dossier",
      "BACK": "Terminer plus tard"
    },
    "TOOLTIP": {
      "DOCUMENTS": "Action 1 : Imprimer le pdf \"Documents pour réparateur\" et mettez TOUS les élements dans le colis.\n SANS FACTURE dans le colis, le produit ne pourra pas être considéré sous GARANTIE",
      "VALIDATION": "Action 2 : Cliquez sur “Déclancher le suivi du dossier” pour activer le suivi transport et finaliser la demande."
    }
  },
  "CURRENT_REPAIR_FILES": {
    "TITLE": "Dossier en cours",
    "SUBTITLE": "Suivez vos dossiers de réparation en cours",
    "SEE_MORE": "Voir plus",
    "DOWNLOAD": "Télécharger",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "Dossier",
      "PRODUCT_NAME": "Nom du produit",
      "COMPANY_NAME": "Nom de l'entreprise",
      "MANUFACTURER_NAME": "Marque",
      "STATUS": "Statut",
      "TIME": "Temps",
      "MODALITY": "Prise en charge",
      "LOADING_REPAIR_FILES": "Chargements des dossiers en cours...",
      "NO_REPAIR_FILE": "Aucun dossier en cours"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin"
    },
    "DAYS": "jours",
    "DAY_WITH_COUNT": "{count} jour",
    "DAYS_WITH_COUNT": "{count} jours"
  },
  "REPAIR_FILE_LIST_PAGE": {
    "TITLE": "Dossiers de réparation",
    "SUBTITLE": "Suivez les dossiers de réparation rattachés à votre centre d'exploitation.",
    "SEARCH": "Rechercher un dossier",
    "NEW_REPAIR_FILE": "Nouveau dossier",
    "FILTER": "Filtrer",
    "EXPORT": "Exporter",
    "EXPORT_REQUEST_SUCCESS": "La demande de génération de l'export est correctement faite. Le fichier sera envoyé par mail d'ici quelques minutes.",
    "EXPORT_REQUEST_FAILED": "La demande de génération de l'export a échoué.",
    "DELETE_FILTER": "Effacer les filtres",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "Dossier",
      "STORE_NAME": "Nom Magasin",
      "COMPANY_NAME": "Entreprise",
      "MANUFACTURER_NAME": "Marque",
      "PRODUCT_NAME": "Produit",
      "RENTAL": "Location",
      "STATUS": "Statut",
      "TIME": "Temps",
      "DATE": "Date",
      "MODALITY": "Pris en charge",
      "LOADING_REPAIR_FILES": "Chargements des dossiers...",
      "NO_REPAIR_FILE": "Aucun dossier"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "EXCLUDING_SUPPORT": "Hors process"
    },
    "FILTERS": {
      "USER_ACTION": "Dossiers nécessitant une action",
      "CURRENT_FOLDER": "Dossiers en cours uniquement",
      "DATE_CREATION": "Date de création",
      "RENTAL": "Avec dossier de location uniquement"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la marque",
      "STATUS_MACRO": "Sélectionnez le statut",
      "MODALITY": "Sélectionnez la modalité",
      "STORE": "Sélectionnez le(s) magasin(s)",
      "REPAIR_CENTER": "Sélectionnez le centre de réparation"
    },
    "DAYS": "jours",
    "DAY_WITH_COUNT": "{count} jour",
    "DAYS_WITH_COUNT": "{count} jours"
  },
  "REPAIR_FILE_DETAIL": {
    "INTERNAL_COMMAND_NUMBER": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "KEY_ACCOUNT_CREATED_BY_CUSTOMER_USER": "Dossier créé par un client utilisateur",
    "MESSAGE": {
      "DELETE": {
        "SUCCESS": "Le dossier a été supprimé avec succès"
      },
      "STATUS_MACRO_UNKNOWN": "Statut du dossier est inconnu",
      "DRAFT": "Le dossier n'a pas encore atteint l'étape de création",
      "DELETED": "Le dossier a été supprimé",
      "NOT_FOUND": "Le dossier n'a pas été trouvé"
    },
    "MODAL": {
      "DELETE_REPAIR_FILE": {
        "TITLE": "Supprimer le dossier",
        "MESSAGE": "Voulez-vous vraiment supprimer le dossier?",
        "WARNING": "Cette action est irréversible."
      }
    },
    "HEADER_RENTAL": {
      "REPAIR": "Réparation",
      "RENTAL": "Location"
    }
  },
  "REPAIR_FILE_DETAIL_ACTION_DRAWER": {
    "TITLE": "Nouvelle action",
    "SUB_TITLE": {
      "CUSTOMER_SUPPORT": "Prise en charge"
    },
    "LAST_RELAUNCH": "Dernière relance : ",
    "CUSTOMER_ESTIMATE_REVISION": "Reprendre le dossier",
    "REPAIRER_ESTIMATE": "Devis réparateur",
    "ADD_ESTIMATE_TO_FILE": "Intégrer le devis du réparateur au dossier",
    "NOTIFY_THE_REPAIRER": "Reprendre le devis du réparateur",
    "CLOSE_CASE": "Clôture",
    "RETRIEVE_EQUIPMENT_CUSTOMER": "Clôturer le dossier",
    "BUTTON": {
      "CONFIRM_COST": "Confirmer coût/prix (sans info. auprès de votre client)",
      "ADD_RENTAL": "Ajouter une pièce jointe"
    }
  },
  "REPAIR_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "IN_CREATION": "1.   En création",
      "TRANSPORT_GO": "2.   Enlèvement aller",
      "RECEPTION_AT_REPAIRER": "3.   Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "4.   Devis envoyé par le fabricant",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "5.   Intégration devis fabricant",
      "ESTIMATE_SENT_TO_CUSTOMER": "6.   Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "7.   Décision client envoyée au réparateur",
      "IN_REPARATION": "8.   En réparation",
      "SENT_BACK_BY_REPAIRER": "9.   Expédition par réparateur",
      "RECEIPT_AT_STORE": "10.   Réception par distributeur",
      "SENT_AVAILABLE_TO_CUSTOMER": "11.   Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "12.   Remise au client - Cloturé",
      "NETWORK_BILLING": "13.   Facturation",
      "FINISHED": "14.   Dossier Terminé"
    },
    "STATUS_ACTION": {
      "VALIDATE_RECEIPT": "Valider réception"
    },
    "REPAIR_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "SUMMARY": "Résumé",
        "SUPPORT": "Prise en charge",
        "CONTACT": "Contact",
        "PRICING": "Tarification détaillée",
        "PROSPECT_FLOW": "Demande de prise en charge préalable",
        "PROGRESSION": "Progression"
      },
      "CLIENT_NUMBER": "N° de compte client",
      "PRODUCT_IMAGE": "Image produit",
      "CLIENT_CODE": "Code client",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "PRODUCT": "Produit",
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :",
      "SUB_CATEGORY": "Sous-gamme :",
      "SERIAL_NUMBER": "Série",
      "LASTNAME": "Nom de l'interlocuteur",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Téléphone",
      "WORKSITE_CODE": "Code spécifique",
      "MODE": "Mode",
      "PRICING": "Tarification client (HT)",
      "SUPPORT": "Prise en charge initialement demandée",
      "GESTION": "Lieu de réparation",
      "ELEMENT": "Éléments concernés",
      "GUARANTEE": "Garantie initiale",
      "UNDER_GUARANTEE": "Sous garantie",
      "OUT_GUARANTEE": "Hors garantie",
      "TRANSPORT_COST": "Coût transport",
      "TRANSPORT_PRICE": "Prix transport",
      "MANAGEMENT_COST": "Coût gestion",
      "MANAGEMENT_PRICE": "Prix gestion",
      "REPAIR_COST": "Prix de réparation",
      "REPAIR_FUND": "Fond de réparation",
      "PACKAGE_CODE": "Code forfait fabricant",
      "PACKAGE_TOTAL_COST": "Coût total (HT)",
      "PACKAGE_SUPPORT_COST": "Prix de la prise en charge (HT)",
      "NETWORK_PACKAGE_CODE": "Code forfait distributeur",
      "ESTIMATE": "Coût devis réparation",
      "ESTIMATE_VALIDATE_BY_CUSTOMER": "Offre validée par client",
      "ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER": "Offre finale client",
      "ESTIMATE_VALIDATE_COST": "Coût facturé par réparateur (HT)",
      "ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST": "Coût facturé par réparateur (HT)",
      "ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST": "Coût transport (HT)",
      "ESTIMATE_VALIDATE_DETAIL_LABOR_COST": "Coût main-d'œuvre (HT)",
      "ESTIMATE_VALIDATE_DETAIL_REPAIR_COST": "Coût total de la réparation (HT)",
      "ESTIMATE_VALIDATE_TRANSPORT_COST": "Prix transport (inclus dans prise en charge) (HT)",
      "ADDITIONAL_REPAIR_COST": "Prix gestion",
      "CUSTOMER_END_COST": "Prix total client (HT)",
      "REPAIR_FILE_IN_PROGRESS": "Dossier en cours",
      "TAKEOVER_BY_CUSTOMER": "Remis au client",
      "NO_PRICE": "- €",
      "CLIENT_LABEL": "Client",
      "REPAIRER_LABEL": "Réparateur",
      "REPAIRER_COST_MAX": "Coût de réparation max (HT)",
      "COMMENT": "Commentaires :",
      "PRICING_STATUS": {
        "PACKAGE_VALIDATED": "Forfait validé par le client",
        "BOSCH_PACKAGE_VALIDATED": "Forfait validé par le client (Besoin de confirmer à BOSCH le devis à venir)",
        "ESTIMATE_TO_INTEGRATE": "Devis à intégrer",
        "WAITING_CUSTOMER_DECISION": "Attente décision clients sur options proposées",
        "ESTIMATE_VALIDATED": "Validation Devis par le client"
      }
    },
    "ESTIMATE_OPTION_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de réparation",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "BUTTON": {
      "NEW_ACTION": "Nouvelle action"
    },
    "ERROR": {
      "MANUAL_UPDATE_INVALID": "La mise a jour manuelle de ce status est impossible"
    }
  },
  "REPAIR_FILE_ATTACHMENT": {
    "TITLE": "Pièces jointes",
    "BUTTON": {
      "ADD": "Ajouter"
    },
    "CARD": {
      "CUSTOMER_SATISFACTION": "Satisfaction client",
      "TRANSPORTER_ORDER": "Étiquette expédition",
      "REPAIR_ORDER": "Ordre de réparation",
      "BILLING": "Facture client",
      "GUARANTEE": "Extension de garantie",
      "FORCE_GUARANTEE": "Garantie forcée",
      "REPAIRER_ESTIMATE": "Devis réparateur",
      "ASBESTOS": "Déclaration amiante",
      "AFTER_SALE_SERVICE": "Fiche SAV client",
      "DANGER_LABEL": "Etiquette produit dangereux",
      "INFO": "(à coller sur colis)",
      "ESTIMATE_PACKAGE": "Devis du forfait",
      "GUARANTEE_EXTENSION_BOOMERANG": "BL à faire signer + Certificat de garantie Boomerang",
      "REPAIR_FILE_PROSPECT_ORDER_WAITING": "Demande préalable",
      "DELIVERY_NOTE": "BL à faire signer",
      "TRANSPORTER_DOCUMENT_FOR_REPAIRER": "Document specifique pour ce réparateur"
    },
    "MODAL": {
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, PNG, JPEG",
      "FILE": "Ajouter votre pièce jointe",
      "FILE_NAME": "Nom du fichier",
      "GENERIC_TITLE": "Ajouter une pièce jointe",
      "GENERIC_SUBTITLE": "Sélectionnez le mode d'ajout",
      "INPUT_LABEL_BY_PC": "Via votre ordinateur",
      "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
      "PC_TITLE": "Ajouter une pièce jointe via ordinateur",
      "QR_CONFIRM": "J'ai ajouté le document",
      "QR_CODE_TITLE": "Ajouter une pièce jointe via QR Code",
      "QR_CODE_SUBTITLE": "Pour ajouter la pièce jointe, scannez le QRCode.",
      "QR_UPLOAD_MISSING": "Aucun document n'a encore été ajouté via QR code.",
      "SUBTITLE": "Ajoutez un fichier depuis cet ordinateur ou générez un QR code pour l'ajouter depuis un mobile.",
      "UPLOAD_VIA_MOBILE": "Ajouter via QR code",
      "VISIBLE_TO_KEY_ACCOUNT": "Document visible pour le client"
    },
    "PLACEHOLDER": {
      "FILE_NAME": "Ex : Nom du fichier"
    },
    "PROSPECT_PICTURE_NAME_LABEL": "Photo-",
    "PROSPECT_DOCUMENT_NAME_LABEL": "Document-",
    "PERMISSION": {
      "VIEW_ATTACHMENT_REPAIR_FILE_DENIED": "Vous n'avez pas les droits requis pour visualiser les pièces jointes du dossier",
      "PRINT_ATTACHMENT_REPAIR_FILE_DENIED": "Vous n'avez pas les droits requis pour télécharger les pièces jointes du dossier"
    }
  },
  "REPAIR_FILE_DELIVERY_CLIENT_DRAWER": {
    "UPDATE_TITLE": "Mise à jour du dossier",
    "CLOSE_TITLE": "Clôture du dossier",
    "SUB_TITLE": {
      "GUARANTEE_INFORMATION": "Information pour prolongation de garantie 6 mois",
      "BILLING_NUMBER": "Numéro Commande Fournisseur",
      "DELIVERY_INFORMATION": "Informations de remise client",
      "BILLING_CLIENT_COST": "Montant facturé au client (HT)",
      "DELIVERY_DATE": "Date de remise client",
      "REPAIR_CHANGE_COST": "Prise en charge",
      "TRANSPORT": "Transport",
      "MANAGEMENT": "Gestion",
      "REF_ERP": "Référence ERP"
    },
    "DETAIL": {
      "DELIVERY_DATE_1": "La date du jour est enregistrée automatiquement.",
      "DELIVERY_DATE_2": "Si vous souhaitez la modifier, sélectionnez une date."
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non-réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non-réparation : retour de la machine démontée"
    },
    "SELECT": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT_BOOMERANG_NAME": "Identifiant du produit",
      "SELECT_PRODUCT": "Sélectionnez un produit",
      "PRODUCT_END_COST": "Coût total facturé par le réparateur (HT)",
      "SERIAL_NUMBER": "Numéro de série",
      "TOTAL_HT": "Total HT"
    },
    "PLACEHOLDER": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT": "Sélectionnez le produit",
      "SEARCH": "999 999 999 999",
      "PRODUCT_END_COST": "Ex : 49,90",
      "BILLING_NUMBER": "Ex : Numéro Commande Fournisseur",
      "REPAIR_CHANGE_COST": "Ex : 49,90",
      "TRANSPORT": "Ex : 12,50",
      "MANAGEMENT": "Ex : 8,00"
    },
    "IMAGE": {
      "SERIAL_NUMBER_ALT": "Aperçu du numéro de série du produit"
    },
    "BUTTON": {
      "SERIAL_NUMBER": "Trouver le numéro de série",
      "SAVE": "Sauvegarder"
    },
    "MESSAGE": {
      "PRODUCT_BOOMERANG_ID_NOT_FOUND": "Votre dossier n’est pas disponible pour le moment.",
      "PROLONGATION_GUARANTEE_FOUND": "Le numéro de série de ce produit possède déjà une prolongation de garantie.",
      "GENERIC_SERIAL_NUMBER": "Ce numéro de série est générique et le produit ne bénéficiera pas de garantie automatique."
    }
  },
  "INFORMATION_REPAIR_FILE": {
    "CLIPBOARD_COPY": "Adresse de contact magasin copiée dans le presse-papiers",
    "CLIPBOARD_COPY_ERROR": "Erreur lors de la copie dans le presse-papiers",
    "CONTENT": "Prise en charge",
    "REPAIR_CENTER": {
      "ADDRESS": "Adresse",
      "EMAIL": "Adresse de contact",
      "ERP_REPAIRER_NUMBER": "Numéro compte réparateur",
      "NAME": "Nom",
      "PHONE": "Numéro de téléphone",
      "REPAIRER_NUMBER": "Numéro de dossier réparateur",
      "TITLE": "Réparateur"
    },
    "STORE": {
      "ADDRESS": "Adresse",
      "EMAIL": "Adresse de contact",
      "NAME": "Nom",
      "PHONE": "Numéro de téléphone",
      "TITLE": "Magasin"
    },
    "TITLE": "Informations",
    "TRANSPORTER_MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "EXCLUDING_SUPPORT": "Hors process"
    },
    "REPAIR_LOCATION": {
      "EXTERNAL_REPAIRER": "Réparateur Externe",
      "STORE_WORKSHOP": "Atelier Magasin",
      "CUSTOMER_WORKSHOP": "Atelier Client"
    }
  },
  "COMMENTARY_REPAIR_FILE": {
    "INFO_ALERT": "L'équipe Boomerang n'est pas alertée de vos commentaires. Afin de nous contacter, appuyez sur le Chat (bulle verte en bas à droite).",
    "BUTTON": {
      "SEND": "Envoyer"
    },
    "HINT": {
      "DESCRIPTION": "Si vous souhaitez nous partager une info ou nous poser une question, veuillez passer par le Chat (bulle verte en bas à droite)",
      "HEADER": "Attention, l'équipe Boomerang n'est pas alertée par vos commentaires."
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    },
    "VISIBILITY": {
      "KEY_ACCOUNT": "Partager avec le client utilisateur",
      "STORE": "Partager avec le magasin"
    },
    "INVISIBLE_TO": "Invisible par {targets}",
    "VISIBILITY_TARGET": {
      "STORE": "Equipe Magasin",
      "KEY_ACCOUNT": "Client Utilisateur"
    },
    "TYPE": {
      "STORE": "Equipe Magasin",
      "KEY_ACCOUNT": "Client Utilisateur",
      "ADMIN": "Equipe BOOMERANG",
      "EXTERNAL": "Externe",
      "REPAIRER": "Réparateur"
    },
    "TITLE": "Commentaires"
  },
  "TRANSPORTER_RENTAL_FILE": {
    "TITLE": "Transport",
    "GO_TO": "Aller",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse",
    "ADDRESS": "Adresse",
    "ADDRESS_COMPLEMENT_1": "Complément 1",
    "ADDRESS_COMPLEMENT_2": "Complément 2",
    "CITY": "Ville",
    "COUNTRY": "Pays",
    "DESIRED_RECEPTION_DATE": "Date de livraison souhaitée",
    "TRACKING_NUMBER": "Numéro de suivi",
    "TRANSPORTER_TYPE": "Transporteur",
    "TRANSPORT_SEND_DATE": "Date d'envoi"
  },
  "TRANSPORTER_REPAIR_FILE": {
    "TITLE": "Adresses A/R",
    "GO_TO": "Aller",
    "GO_DEPARTURE_ADDRESS": "ALLER - ADRESSE DE DEPART",
    "GO_DESTINATION_ADDRESS": "ALLER - ADRESSE DESTINATAIRE",
    "RETURN_TO": "Retour",
    "RETURN_REPAIRER_ADDRESS": "RETOUR - ADRESSE RETOUR",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse",
    "ADDRESS": "Adresse",
    "CITY": "Ville",
    "TRANSPORT_TYPE": "Type de transport",
    "TRANSPORTER": "Transporteur",
    "FINALIZATION_DATE": "Date finalisation dossier",
    "COLLECT_STATUS": "Demande de ramasse",
    "EXPEDITION_DATE": "Date expédition",
    "TRACKING_NUMBER": "Numéro de tracking",
    "PACKAGE_WEIGHT": "Poids du colis",
    "PALLET": "Transport avec palette",
    "TRANSPORTER_LOGIN": "Login du contrat transporteur",
    "TYPE": {
      "IMMEDIATE_TRANSPORTER": "Transporteur immédiat",
      "CUSTOMER_SERVICE_TRANSPORTER": "Transporteur du service client",
      "WITHOUT_TRANSPORTER": "Sans transporteur"
    },
    "TRANSPORTER_NAME": {
      "CHRONOPOST": "Chronopost"
    }
  },
  "CUSTOMER_RECOVERY": {
    "TITLE": "Relance client",
    "REMINDER": "Rappels",
    "LAST_FOLLOW_UP": "Dernière relance le: ",
    "DIALOGUE": {
      "MESSAGE": "Voulez vous vraiment cacher cette relance ?",
      "VALIDATION_BUTTON": "Oui",
      "CANCEL_BUTTON": "Non"
    }
  },
  "PUBLIC": {
    "OPTION": {
      "SUCCESS_EMAIL_SEND_WITH_ATTACHMENT": "Les informations et la pièce jointe sont bien ajoutées au dossier.",
      "ERROR_PROSPECT_MANUFACTURER_RESPONSE_INFORMATION_SEND": "L'envoi des informations est bloqué - Contacter {supportAddress}"
    },
    "ESTIMATE_REPAIRER_CLIENT_OPTION": {
      "CONFIRMATION": {
        "REQUEST": "Vous avez demandé :",
        "TOTAL_COST": "Montant (HT) :",
        "BUTTON": "Je confirme cette décision",
        "EMAIL_FALLBACK": "Si vous souhaitez une autre option, reprenez l'email initial"
      },
      "TITLE": "Merci pour votre retour !",
      "MESSAGE": "Votre décision sur la réparation a bien été prise en compte par votre magasin",
      "PURCHASE_ORDER_MESSAGE": "Si vous devez envoyer un bon de commande à votre magasin, cliquez ci-dessous",
      "PURCHASE_ORDER_FORM_MESSAGE": "Formulaire du bon de commande",
      "TOGGLE_TEXT": "Ajouter une pièce jointe",
      "TOGGLE_MESSAGE": "File supported: pdf, jpg, png",
      "FORM": {
        "ORDER_NUMBER": "N° de commande",
        "CALLBACK_REF": "Référence à rappeler",
        "ATTACHMENT": "Ajouter votre pièce jointe"
      }
    },
    "ESTIMATE_PACKAGE_CLIENT_OPTION": {
      "TITLE": "Merci pour votre retour !",
      "MESSAGE": "Votre décision sur le devis de réparation a bien été prise en compte par votre magasin",
      "PURCHASE_ORDER_MESSAGE": "Si vous devez envoyer un bon de commande à votre magasin, cliquez ci-dessous",
      "PURCHASE_ORDER_FORM_MESSAGE": "Formulaire du bon de commande",
      "TOGGLE_TEXT": "Ajouter une pièce jointe",
      "TOGGLE_MESSAGE": "File supported: pdf, jpg, png",
      "FORM": {
        "ORDER_NUMBER": "N° de commande",
        "CALLBACK_REF": "Référence à rappeler",
        "ATTACHMENT": "Ajouter votre pièce jointe"
      }
    }
  },
  "ESTIMATE_REPAIRER": {
    "TITLE": "Devis réparateur",
    "TITLE_CHOICE": "Choix du client",
    "ATTACHMENT": "Devis du réparateur",
    "ATTACHMENT_ACTION": "Ajouter le devis",
    "ATTACHMENT_INFO": "Le document sera ajouté aux pièces jointes du dossier.\nLes différentes offres présentes dans le devis devront ensuite être créées une par une dans BOOMERANG.",
    "GUARANTEE_WARNING": "Attention – Produit sous garantie\n\nCe produit est actuellement identifié comme étant sous garantie.\nSi le fabricant vous transmet un devis payant, vérifiez qu’il s’agit bien d’une exclusion de garantie avant de poursuivre.",
    "ATTACHMENT_UPDATE": "Modifier le devis",
    "ATTACHMENT_UPLOADED": "Document déjà ajouté",
    "ATTACHMENT_MODAL_TITLE": "Ajouter le devis du réparateur",
    "REPAIRER_NUMBER": "Numéro de devis indiqué par votre réparateur",
    "PLACEHOLDER": {
      "REPAIRER_NUMBER": "N°1234"
    },
    "HINT": {
      "REPAIRER_NUMBER": "Pour la bonne prise en charge de votre dossier, merci d’indiquer uniquement le N° de devis fourni par le réparateur.\nDans le cas de BOSCH, il s’agit impérativement du N° d’Ordre (exemple : 2506230xxx ou 0306000xxx)."
    }
  },
  "ESTIMATE_REPAIRER_OFFER": {
    "SUB_TITLE": "Offre du réparateur",
    "TITLE_FORM": "Veuillez indiquer les coûts du fabricant",
    "TRANSPORT_COST": "Coût réparateur dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main-d'œuvre",
    "MARGIN": "Marge",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "DETAIL_CLIENT": "Détail pour le client",
    "CLIENT_PRICE": "Prix client",
    "CLIENT_PRICE_HT": "Prix client (HT)",
    "REPAIRER_COST_SHORT": "Coût rép.",
    "NEW_OFFER": "Nouvelle offre",
    "OFFER_TYPE": "Type d'offre",
    "REPAIR_COST_HT": "Coût réparation (HT)",
    "TRANSPORT_HT": "Transport (HT)",
    "LABOR_HT": "Main d'œuvre (HT)",
    "INFO_CLIENT": "N'oubliez pas d'inclure une option de non-réparation pour le client",
    "PLACEHOLDER": {
      "OFFER_TYPE": "Sélectionner un type d'offre",
      "COMMENT": "Détail pour client",
      "ESTIMATE_COST": "Ex : 49,90",
      "LABOR_COST": "Ex : 49,90",
      "TRANSPORT_COST": "Ex : 49,90",
      "END_STATUS": "N°1234"
    },
    "BUTTON": {
      "ADD_FORM": "Ajouter une offre du réparateur",
      "SAVE": "Sauvegarder",
      "VALIDATE_OFFER": "Valider l'offre"
    }
  },
  "ESTIMATE_REPAIRER_DETAIL": {
    "SUB_TITLE": {
      "SUMMARY": "Montant à proposer au client (HT)",
      "INFORM_CLIENT": "Informer le client"
    },
    "CUSTOMER_EMAIL_SAVE": " L'email du client a été sauvegardé",
    "CALL_CLIENT": "J’appelle le client et l’informe des tarifs",
    "SEND_ESTIMATE": "Envoyer un devis avec ces options",
    "BUTTON": {
      "SEND_EMAIL": "Envoyer les options par email",
      "RESPONSE_CLIENT": "Le client me répond tout de suite",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "PLACEHOLDER": {
      "COMMENT": "Commentaire"
    },
    "MODAL": {
      "SEND_CLIENT_EMAIL": "Les options ont bien été envoyées par mail au client"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE": {
    "SUB_TITLE": "Offre du réparateur",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "MARGIN": "Marge",
    "TRANSPORT_COST": "Coût rép. dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main d'œuvre",
    "SEND_ESTIMATE_AGAIN": "Renvoyer le devis par email",
    "BUTTON": {
      "SEND_EMAIL": "Renvoyer les options du devis par email"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION": {
    "TITLE": "Informer le réparateur et le client",
    "SUB_TITLE": {
      "CONTACT_REPAIRER": "1. Confirmer au réparateur le coût de la réparation",
      "CONTACT_CLIENT": "2. Confirmer au client la validation"
    },
    "LABEL": {
      "REPAIRER_PRICE": "Coût réparation",
      "REPAIRER_PHONE": "Téléphone réparateur",
      "REPAIRER_EMAIL": "Email réparateur",
      "CUSTOMER_PHONE": "Téléphone client",
      "CUSTOMER_EMAIL": "Email client"
    },
    "BUTTON": {
      "SAVE": "Confirmer par mail automatiquement",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "VALIDATION": "Les options ont bien été envoyées par mail au client et au réparateur"
  },
  "UPDATE_STATUS_FORM_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Mettez à jour le statut du dossier et sélectionnez la date si différente de la\ndate du jour et validez",
    "PLACEHOLDER": "Statut disponible",
    "PICKUP_PLACE": "Lieu où récupérer le produit"
  },
  "UPDATE_STATUS_CONFIRMATION_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Voulez-vous vraiment mettre à jour le statut du dossier? Cette action est irréversible.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_1": "Attention! À la validation de ce statut, vous ne pourrez pas ajouter de devis dans Boomerang.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_1": "Pour ajouter un devis, cliquer sur",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_2": "Nouvelle action",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_3": "puis",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_4": "Intégrer le devis au dossier",
    "SUB_MESSAGE": "La date de mise à jour est enregistrée automatiquement. Si vous souhaitez la modifier, sélectionnez une date.",
    "PASS_MESSAGE": "Ajouter les photos via les pièces jointes",
    "RECEIPT_AT_STORE_TITLE": "Informez votre client que son produit a été retourné",
    "PHONE_NOTIFICATION": {
      "TITLE": "Par téléphone",
      "CALL": "Appel",
      "SMS": "SMS"
    },
    "TAKEOVER_TYPE": {
      "TITLE": "Par email",
      "PICK_UP": "Produit dispo en magasin",
      "SEND_BY_STORE": "Le produit va être livré au client"
    }
  },
  "NOTIFICATION": {
    "BUTTON": {
      "MORE": "Voir plus"
    },
    "LOADING_NOTIFICATION": "Chargement des notifications",
    "NO_NOTIFICATION": "Aucune notification a afficher"
  },
  "GUARANTEE_EXTENSION_BOOMERANG_MODAL": {
    "TITLE": "Extension de garantie de réparation",
    "BODY_1": "Le produit de votre client est sous garantie jusqu'au",
    "BODY_2": "Cette date est visible sur le certificat d'extension de garantie rattaché au dossier que vous pouvez imprimer ci-dessous.",
    "SEND_BY_EMAIL_MESSAGE": "Partager le certificat par email",
    "PROOF_TITLE": "Bon Livraison + Certificat Extension de Garantie",
    "SUCCESS_SENT": "Le certificat a bien été envoyé a l'adresse email"
  },
  "RENTAL_FILE_WELCOME": {
    "TITLE": "Bienvenue sur Boomerang location",
    "SUBTITLE": "Découvrez notre sélection de produits électroportatifs à louer, idéale pour ne pas rester sans matériel pendant la réparation de son équipement.",
    "EMPTY": "Aucun produit ne correspond à votre recherche et aux disponibilités sélectionnées.",
    "LOAD_ERROR": "Impossible de charger les produits de location. Veuillez réessayer.",
    "FIND_PRODUCT": "Trouver votre produit",
    "SELECT_ALL": "Tout voir",
    "AVAILABILITY_STATUS_GROUP": "Disponibilité",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Disponible",
      "IN_COMING": "À venir",
      "UNAVAILABLE": "Indisponible"
    },
    "AVAILABILITY_ERROR": "Vous ne pouvez pas sélectionner un produit non disponible"
  },
  "RENTAL_PRODUCT_DETAIL": {
    "TITLE": "Détail du produit de location",
    "SERIAL_NUMBER": "Numéro de série : {number}",
    "RENTAL_PRICE": "Prix de location HT",
    "PRODUCT_SHEET": "Fiche produit",
    "SPECIFICATIONS": "Caractéristiques",
    "CONSUMABLE_REFERENCE": "Réf. {reference}",
    "CONTRACT_DETAILS_HINT": "Les détails du contrat vous seront demandés à la création du dossier.",
    "FIELDS": {
      "BRAND": "Marque",
      "CATEGORY": "Gamme",
      "MODEL": "Modèle",
      "REFERENCE": "Référence",
      "SUB_CATEGORY": "Sous-catégorie",
      "WEIGHT": "Poids",
      "LENGTH": "Longueur",
      "WIDTH": "Largeur"
    },
    "NO_PICTURE": "Photo du produit indisponible",
    "CONSUMABLE_PICTURE": "Photo du consommable"
  },
  "RENTAL_MODULE_PRODUCT_DETAIL_PAGE": {
    "DEPOSIT": "Caution",
    "CONSUMABLE_TEXT": "Pensez à proposer ces consommables",
    "SUMMARY_TEXT": "Demander un contrat de location",
    "HT_PRICE": "Sous total",
    "DELIVERY_TOTAL": "Livraison à partir de",
    "FREE_DELIVERY": "GRATUIT",
    "HT_TOTAL": "Total HT",
    "CREATE_RENT_BUTTON": "Créer un contrat de location"
  },
  "RENTAL_FILE_CREATE": {
    "LOAD_ERROR": "Impossible de charger le formulaire de location. Veuillez réessayer.",
    "DATE_ERROR": "Sélectionnez une date de livraison valide, aujourd'hui ou ultérieure.",
    "SAME_BILLING_ADDRESS": "Adresse de facturation identique à l'adresse de livraison",
    "SECTIONS": {
      "DELIVERY_ADDRESS": "Adresse de livraison",
      "BILLING_ADDRESS": "Adresse de facturation",
      "DELIVERY_DEPOSIT": "Livraison et caution",
      "ADDITIONAL_INFORMATION": "Informations complémentaires"
    }
  },
  "RENTAL_MODULE_CREATE_FILE_PAGE": {
    "NEXT_STEP_CARD": {
      "TITLE": "Prochaines étapes pour valider la demande de location",
      "P1": "1. Renseigner le formulaire et envoyer la demande de location",
      "P2": "2. Sous 1h le client reçoit son contrat par email via WeSign et la demande de caution par email et téléphone via Swikly (si caution par gérée par le magasin)",
      "P3": "3. Envoi de la machine par transporteur à l’adresse et date de livraison souhaitée*, une fois le contrat signé et la caution validée",
      "P3_DOT": "*les demandes gérées avant 11h sont livrés à J+1 et les demandes gérées après 11h sont livrés à J+2",
      "P4": "4. Réception et utilisation de la machine le temps de la réparation",
      "P5": "5. Une fois le produit réparé, le client est informé par le magasin. Le client a 48h pour retourner la machine en magasin",
      "SP2": "Surcout contractuel",
      "SP2_1": "passé 48h 29 € seront facturés par jour supplémentaire",
      "SP2_2": "si la machine n’est pas retournée dans l’état initial un forfait de nettoyage de 29€ pourrait être appliqué",
      "P6": "6. Envoi de la machine par le magasin à Boomerang",
      "P7": "7. Vérification de la machine et déblocage de la caution par Boomerang"
    },
    "FORM": {
      "TITLE": "Formulaire contrat de location",
      "COMPANY_NAME_LABEL": "Nom d'entreprise",
      "CLIENT_FULLNAME_LABEL": "Nom du signataire du contrat",
      "CLIENT_EMAIL_LABEL": "E-mail du signataire du contrat",
      "CLIENT_PHONE_NUMBER_LABEL": "Téléphone du signataire",
      "COMPANY_ADDRESS_NAME_LABEL": "Nom de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_STREET_LABEL": "Rue de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_CITY_LABEL": "Ville de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de l'entreprise",
      "BILLING_ADDRESS_STATUS_LABEL": "Adresse de livraison similaire à l’adresse de facturation",
      "BILLING_ADDRESS_NAME_LABEL": "Nom de l'adresse de facturation",
      "BILLING_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de facturation",
      "BILLING_ADDRESS_STREET_LABEL": "Rue de l'adresse de facturation",
      "BILLING_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de facturation",
      "BILLING_ADDRESS_CITY_LABEL": "Ville de l'adresse de facturation",
      "BILLING_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de facturation",
      "DESIRED_DELIVERY_DATE_LABEL": "Date de livraison souhaitée",
      "DEPOSIT_LABEL": "Gestion de la caution",
      "DEPOSIT_VALUE_1_LABEL": "Caution gérée par le distributeur sur le compte du client",
      "DEPOSIT_VALUE_2_LABEL": "Caution en ligne via Boomerang et son partenaire Swikly (max 4.50€ de dossier)",
      "COMMENT_LABEL": "Commentaire",
      "COMMENT_PLACEHOLDER": "Commentaire spécifiques (Ex: Le client ne sera pas présent à l'atelier)",
      "CARD_LABEL": "Conditions générales de location courte durée",
      "VALIDATION": "Envoyer la demande de location"
    }
  },
  "RENTAL_FILE_DETAIL": {
    "BOOMERANG_ID": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "CLIENT_NAME": "Client : ",
    "NOT_FOUND": "Le dossier de location n'a pas pu être trouvé",
    "STATUS_UNKNOWN": "Statut du dossier de location inconnu",
    "STATUS": {
      "CREATED": "Création du dossier",
      "CONTRACT_SENT": "Envoi contrat",
      "PACKET_PREPARATION": "Préparation Colis",
      "TRANSPORT_GO": "Transport aller",
      "CLIENT_RECEIPT": "Réception client",
      "CLIENT_INFORMED": "Client informé dispo",
      "STORE_RECEIPT": "Réception location en magasin",
      "TRANSPORT_BACK": "Transport Retour",
      "BOOMERANG_RECEIPT": "Réception Boomerang",
      "BILLING": "Facturation hors cadre",
      "CLOSED": "Clôture"
    }
  },
  "COMMENTARY_RENTAL_FILE": {
    "TITLE": "Commentaires",
    "INFO_ALERT": "L'équipe Boomerang n'est pas alertée de vos commentaires. Afin de nous contacter, appuyer sur le Chat (bulle verte en bas à droite).",
    "BUTTON": {
      "SEND": "Envoyer"
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    }
  },
  "DAY_SUPP_COUNT_DATE_RENTAL_FILE": {
    "TITLE_1": "Nombre de jours additionnels",
    "TITLE_2": "(A partir de J+2 du retour SAV)",
    "DAYS": "Jours"
  },
  "RENTAL_FILE_ATTACHMENT": {
    "TITLE": "Pièces jointes",
    "CARD": {
      "CGV": "CGV",
      "ADD_ATTACHMENT": "Ajouter une pièce jointe"
    },
    "BUTTON": {
      "ADD": "Ajouter"
    },
    "MODAL": {
      "FILE_NAME": "Nom du fichier",
      "FILE": "Ajouter votre pièce jointe"
    },
    "PERMISSION": {
      "VIEW_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour voir les pieces jointes",
      "PRINT_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour telecharger cette piece jointe"
    }
  },
  "RENTAL_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "CREATED": "1. Création du dossier",
      "CONTRACT_SENT": "2. Envoi contrat",
      "PACKET_PREPARATION": "3. Préparation Colis",
      "TRANSPORT_GO": "4. Transport aller",
      "CLIENT_RECEIPT": "5. Réception client",
      "CLIENT_INFORMED": "6. Client informé dispo",
      "STORE_RECEIPT": "7. Réception location en magasin",
      "TRANSPORT_BACK": "8. Transport Retour",
      "BOOMERANG_RECEIPT": "9. Réception Boomerang",
      "BILLING": "10. Facturation hors cadre",
      "CLOSED": "11. Clôture"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de location",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "RENTAL_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "SUMMARY": "Résumé",
        "PRICING": "Tarification détaillée"
      },
      "MANUFACTURER": "Marque :",
      "CATEGORY": "Gamme :",
      "SUB_CATEGORY": "Sous-gamme :",
      "PRODUCT": "Produit :",
      "PRODUCT_IMAGE": "Image produit",
      "SERIAL_NUMBER": "Série",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Nom du signataire",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Téléphone",
      "CLIENT_RENTAL_COST": "Prix client location",
      "CLIENT_RENTAL_COST_PACKAGE_NAME": "Forfait client location",
      "CLIENT_ADDITIONAL_DAY_COST": "Prix client / jour additionnel",
      "CLIENT_ADDITIONAL_DAY_PACKAGE_NAME": "Forfait client / jour additionnel",
      "DEPOSIT": "Caution",
      "DEPOSIT_TYPE": "Dépôt de caution"
    },
    "DEPOSIT_TYPE": {
      "STORE": "Magasin",
      "SWIKLY": "Swikly"
    }
  },
  "RENTAL_UPDATE_STATUS_STORE_RECEIPT_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo du produit.",
    "MESSAGE_2": "Pour ajouter une photo, scannez le QRCode et ajouter une photo du produit au dossier.",
    "RETRY_QR_CODE": "Réessayer",
    "ERROR": {
      "INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR_KEY": "Aucune photo du produit n'a été ajoutée au dossier. Merci d'ajouter au moins une photo pour passer à l'étape suivante."
    }
  },
  "STEP_PROSPECT": {
    "TITLE": "Information dossier",
    "SUB_STEP_INFORMATION_CLIENT": {
      "TITLE": "Information du contact Entreprise pour la gestion de ce SAV"
    },
    "SUB_STEP_PROSPECT_REQUEST": {
      "TITLE": "Demande de prise en charge préalable",
      "REFERENCE_IMAGE_ALT": "Modèle de photos pour la demande préalable",
      "RIGHT_PART": {
        "ADD_PICTURE": {
          "TITLE": "Ajouter des photos demandées sur le modèle pour compléter le dossier",
          "SUBTITLE": "Cliquer sur l’option de votre choix ci-dessous",
          "INPUT_LABEL_BY_PC": "Via votre ordinateur",
          "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
          "ADD_SUCCESS": "Ajout de la photo fait avec succès",
          "REMOVE_SUCCESS": "Suppression de la photo fait avec succès",
          "PICTURE_NAME_LABEL": "Photo-"
        },
        "ADD_DOCUMENT": {
          "TITLE": "Ajouter des pièces supplémentaires à joindre au dossier",
          "INPUT_LABEL": "Ajouter un document",
          "ADD_SUCCESS": "Ajout du document fait avec succès",
          "PARTIAL_UPLOAD": "Certains documents n'ont pas été ajoutés. Vérifiez la sélection et réessayez avant d'envoyer la demande.",
          "REMOVE_SUCCESS": "Suppression du document fait avec succès",
          "DOCUMENT_NAME_LABEL": "Document-"
        },
        "MORE_INFO": {
          "TITLE": "Détailler les informations permettant de faciliter la prise en charge",
          "SUBTITLE": "(Désignation modèle exact si non précisé précédemment, Référence Fournisseur, Taille, Couleur, etc)",
          "INPUT_LABEL": "Exemple : la fermeture éclair a arraché toutes les coutures",
          "READ_CONFIRMATION": "J'ai bien intégré toutes ces informations"
        }
      },
      "MESSAGE": {
        "SENT_SUCCESS": "La demande a était envoyé avec succès",
        "PARTIAL_SUCCESS": "Le dossier est sauvegardé avec succès"
      },
      "BUTTON": {
        "VALIDATE": "Valider la demande préalable"
      },
      "MODAL": {
        "TITLE": "Demande de prise en charge préalable au réparateur",
        "PROSPECT_PDF_LABEL": "Demande de prise en charge",
        "TITLE_EMAIL": "Envoyer la demande au réparateur par email",
        "PLACEHOLDER_EMAIL": "Email du réparateur",
        "INFORMATION": "Tous les documents et commentaires seront envoyés au réparateur pour un diagnostic complet.",
        "VALIDATION_BUTTON": "Envoyer au réparateur",
        "BOTTOM_TEXT": "Suite à cette demande, le dossier sera sauvegardé dans l'attente du retour du réparateur"
      }
    },
    "SUB_STEP_PROSPECT_RESPONSE": {
      "WAITING": "Demande envoyée. En attente de la réponse du fabricant. Vous pouvez aussi saisir une réponse reçue directement.",
      "RESPONSE_RECEIVED": "Vérifiez et validez la réponse du fabricant avant de continuer.",
      "REFRESH": "Actualiser la réponse",
      "REFRESH_TITLE": "Actualiser la réponse du fabricant ?",
      "REFRESH_MESSAGE": "Vos modifications non enregistrées seront remplacées par la réponse enregistrée.",
      "COMPUTER_SUBTITLE": "Ajoutez un fichier depuis cet ordinateur.",
      "TITLE": "Retour du fabricant après demande de prise en charge",
      "PLACEHOLDER": {
        "SUPPORT_NUMBER": "Saisir le numéro de prise en charge",
        "COMMENT": "Précisez le retour du fabricant et les instructions utiles au magasin"
      },
      "MANUFACTURER_SUPPORT_LABEL": "Prise en charge par le fabricant",
      "MANUFACTURER_OPTION": {
        "PRODUCT_REPAIR_WITH_GUARANTEE": "Réparation sous garantie",
        "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Retour du produit pour diagnostic",
        "CREDIT_OR_REFUND": "Avoir / Remboursement",
        "PRODUCT_REPLACEMENT": "Echange par un produit neuf",
        "TECHNICIAN_ON_SITE_INTERVENTION": "Intervention sur site d'un technicien",
        "REJECT_PROSPECT": "Refus - Non réparation et clôture du dossier",
        "OTHER": "Autre"
      },
      "MESSAGE": {
        "VALIDATE_SUCCESS": "Validation de la réponse du fabricant sauvegardée"
      },
      "MODAL": {
        "TITLE": "Confirmer le retour du fabricant",
        "MESSAGE": "La confirmation engendre des actions sur le dossier, vous ne pourrez pas revenir en arrière"
      }
    }
  },
  "REPAIR_FILE_PROSPECT_ADD_PICTURE": {
    "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
    "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
  },
  "PUBLIC_PROSPECT": {
    "TITLE": "Merci pour votre retour !",
    "EMAIL_LABEL": "Emails à qui envoyer l'information (Ne pas mettre l'{'@'} magasin qui est déjà informé)",
    "EMAIL_PLACEHOLDER": "Ex : emailduréparateur.com; votreemail.com; (séparés par ';')",
    "EMAIL_CHECKBOX_REPAIRER": "Envoyer les informations sur {email}",
    "EMAIL_CHECKBOX_SUPPORT": "Envoyer les informations sur {email}",
    "MESSAGE": "Votre décision sur la demande de prise en charge a bien été prise en compte",
    "MANUFACTURER_INFO_MESSAGE": "Renseigner le détail du dossier dans les champs ci-dessous",
    "SUPPORT_NUMBER_LABEL": "N° de la demande de prise en charge",
    "MANUFACTURER_COMMENT_LABEL": "Commentaire",
    "RETURN_ADDRESS": "Commentaire pour le magasin / Adresse de retour si besoin de préciser",
    "MANUFACTURER_ATTACHMENT_LABEL": "Ajouter une pièce jointe",
    "TITLE_FORM_SENT": "Merci, les informations ont bien été sauvegardées"
  },
  "RENTAL_WARNING_MODAL": {
    "TITLE": "Noubliez pas de récupérer le produit en location",
    "MESSAGE": "Attention! Un dossier de location est lié au dossier de réparation. Avant de clôturer le dossier pensez à récupérer la machine en location et clôturer le dossier."
  },
  "ATTACHMENT_MODAL": {
    "QR_CODE_PAGE": {
      "TITLE": "Ajout de la piece jointe",
      "MESSAGE": "Pour mettre à jour le dossier vous devez ajouter une piece jointe.",
      "SELECT_TITLE": "Sélectionner votre pièce jointe :",
      "TITLE_SENT": "Merci, votre pièce jointe est bien ajoutée au dossier",
      "MESSAGE_SENT": "Vous pouvez à présent poursuivre sur la plateforme",
      "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG",
      "LOADING": "Vérification du lien...",
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, JPEG, PNG",
      "TAKE_PHOTO": "Prendre une photo",
      "REMOVE_FILE": "Supprimer le fichier",
      "TITLE_FAILED": "Impossible de vérifier ce lien",
      "MESSAGE_FAILED": "Une erreur est survenue. Vous pouvez réessayer."
    }
  },
  "RECYCLING_MODULE": {
    "RECYCLING_PAGE": {
      "TITLE": "Recyclage",
      "SUBTITLE": "Suivez vos produits recyclés, leur valeur de rachat et le remplissage de vos bacs.",
      "GREEN": {
        "TITLE": "Rapport de recyclage",
        "TEXT_1": "Les Équipements Électriques et Électroniques (EEE) contiennent des matières polluantes pour l’environnement, mais représentent aussi un fort potentiel de recyclage des matériaux qui les composent.",
        "TEXT_2": "La démarche est établie par les éco-organismes en charge de la filière de recyclage des piles et accumulateurs portables ainsi que les eco-organismes DEEE."
      },
      "MAIN": {
        "TITLE": "Rapport de recyclage",
        "REPORT": {
          "RECYCLER": {
            "TITLE": "Nombre de produits recyclés"
          },
          "BUYBACK": {
            "TITLE": "Valeur de rachat des produits recyclés"
          }
        },
        "BATTERIES": {
          "TITLE": "Consultez la procédure de conditionnement et stockage du Lithium"
        },
        "RECYCLED_PRODUCT_LIST": {
          "TITLE": "Téléchargez le listing complet des produits recyclés"
        },
        "TABLE": {
          "LOADING": "Chargements des BAC en cours...",
          "EMPTY": "Aucun BAC trouvé",
          "HEADER": {
            "NAME": "Nom",
            "LOGO": "Logo",
            "FILLING": "Remplissage"
          },
          "LOGO_ALT": "Logo de {name}",
          "BUTTON": "Déclencher la ramasse",
          "COLLECTION_TRIGGER_SUCCESS": "Votre demande de ramasse est bien communiquée. Le partenaire prendra rapidement contact avec vous"
        }
      },
      "BUTTON": {
        "NEW_RECYCLING_FOLDER": "Recycler un produit"
      }
    },
    "STEPPER": {
      "TITLE": "Recyclage de matériel professionnel",
      "SUBTITLE": {
        "PRODUCT_INFORMATION": "Identifiez le produit à recycler et renseignez son état.",
        "PRODUCT_CHECKING": "Vérifiez les conditions de reprise avant de confirmer la cession.",
        "PRODUCT_PACKAGING": "Choisissez le stockage adapté au produit et confirmez sa cession."
      },
      "ARIA_LABEL": "Étapes de création du dossier de recyclage",
      "LOAD_ERROR": "Impossible de charger les informations de recyclage.",
      "NO_FOLDER": "Aucun dossier créé",
      "STEP": {
        "PRODUCT_INFORMATION": "Informations du produit",
        "PRODUCT_CHECKING": "Vérification",
        "PRODUCT_PACKAGING": "Conditions de stockage"
      }
    },
    "SUMMARY": {
      "PRODUCT_TITLE": "Produit sélectionné",
      "SOURCE_IMAGE": "Photo du produit",
      "CHECKING_TITLE": "État et reprise",
      "PRODUCT": "Produit",
      "MANUFACTURER": "Marque",
      "SERIAL_NUMBER": "N° série",
      "COMPANY": "Entreprise",
      "CONDITION": "État",
      "BUYBACK_PRICE": "Montant de reprise",
      "CLIENT_SHARE": "Montant reversé au client",
      "STORE_SHARE": "Montant conservé par le magasin"
    },
    "STEP_PRODUCT_INFORMATION": {
      "TITLE": "Enregistrement de mon produit",
      "TITLE_CONDITION": "État du produit",
      "NO_PICTURE": "Sélectionnez votre produit",
      "FORM": {
        "LABEL": {
          "COMPANY_NAME": "Nom de l'entreprise",
          "DEPOSIT_DATE": "Date de dépot",
          "MANUFACTURER": "Marque",
          "PRODUCT": "Rechercher mon produit",
          "PRODUCT_NOT_FOUND": "Mon produit n’est pas dans la liste",
          "ADD_PRODUCT_MESSAGE": "Vous pensez que votre produit a de la valeur ? Contactez Boomerang par le Chat ou au 06 69 51 56 64",
          "SERIAL_NUMBER": "Numéro de série"
        },
        "PLACEHOLDER": {
          "COMPANY_NAME": "Votre entreprise",
          "MANUFACTURER": "Rechercher ma marque",
          "PRODUCT": "Rechercher mon produit",
          "SERIAL_NUMBER": "999 999 999 999"
        }
      }
    },
    "STEP_PRODUCT_CHECKING": {
      "SUBTITLE": "Vérifiez les conditions de reprise et la répartition du montant.",
      "RECYCLER": {
        "TITLE": "Vérification de l'état",
        "SUB_1": "Oups, cette machine ne peut pas être reprise...",
        "SUB_2": "Mais elle a encore de la valeur !",
        "TEXT_1": "Confiez-la nous pour un recyclage responsable.",
        "TEXT_2": "Nous trierons ses composants avec soin : les matières premières récupérable seront réutilisées ou transmises à nos partenaires spécialisés pour un recyclage optimal.",
        "TEXT_3": "Ensemble, donnons une seconde vie aux matériaux."
      },
      "RECONDITIONER": {
        "TITLE": "Vérification de l'état",
        "SUB_1": "Ajouter des photos du produit",
        "TEXT_1": "Rajouter 1 photo qui permettra au prestataire de valoriser la reprise du produit.",
        "TEXT_2": "Photo de la plaque signalétique.",
        "TEXT_3": "Si plaque absente : photo de la machine à plat",
        "ADD_ATTACHMENT": {
          "INPUT_LABEL_BY_PC": "Via votre ordinateur",
          "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
          "ADD_SUCCESS": "Ajout de la photo fait avec succès",
          "REMOVE_SUCCESS": "Suppression de la photo fait avec succès",
          "PICTURE_NAME_LABEL": "Photo-"
        },
        "CGU_LABEL": "J’ai bien pris en compte que le prix de reprise est proposé sous réserve que la machine soit bien dans l'état déclaré. Une photo de la machine est ajoutée pour confirmer la cession et assurer la traçabilité de l’équipement."
      },
      "CONDITION_LABEL": "État",
      "BUYBACK_PRICE_LABEL": "Reprise",
      "BUYBACK_PRICE_CLIENT_LABEL": "Montant reversé au client",
      "BUYBACK_PRICE_STORE_LABEL": "Montant conservé par le magasin"
    },
    "STEP_PRODUCT_PACKAGING": {
      "TITLE": "Conditions de stockage",
      "SUBTITLE": "Préparez le stockage du produit et son certificat de cession.",
      "BATTERY_LABEL": "Présence d'une batterie",
      "CONDITION_LABEL": "État",
      "BUYBACK_PRICE_LABEL": "Reprise",
      "BAC_DESIGNATION_LABEL": "Bac de recyclage",
      "DOWNLOAD_LINK_TEXT": "Télécharger le certificat de cession du produit",
      "FORM": {
        "MAIL": "Envoyer le certificat par email"
      },
      "PLACEHOLDER": {
        "MAIL": "Adresse e-mail"
      },
      "BATTERY_WARNING": {
        "WITHOUT_BATTERY": "DANGER Batterie ! Je déclare qu'aucune batterie n'est recyclée avec ce produit (Responsabilité engagée du magasin)",
        "WITH_BATTERY": "DANGER Batterie ! Je recycle une batterie et respecte les conditions de stockage (Responsabilité engagée du magasin) - Voir condition de stockage"
      },
      "MODAL": {
        "TITLE": "Confirmation",
        "MESSAGE": "En validant cette étape, vous confirmez que le client a été informé de la cession immédiate de son produit envers votre entreprise. Votre entreprise devient donc propriétaire/responsable de ce produit dans l'attente d'une future cession à un tier."
      },
      "SUCCESS": "Le dossier a bien été enregistré"
    },
    "RECYCLING_REPORT_PAGE": {
      "TITLE": "Analyse performance environnementale",
      "SUBTITLE": "Impact évité par vos réparations, réemplois et recyclages, calculé sur le référentiel ACV.",
      "GREEN": {
        "TITLE": "Rapport de votre performance environnementale",
        "TEXT": "Parce qu’évaluer la valeur d’un produit ne peut pas se faire seul, nous avons réuni 5 entreprises pour co-construire un calculateur basé sur l’expérience terrain. Ensemble, nous avons défini un référentiel marché juste, aligné avec les réalités opérationnelles. Ce référentiel, vivant et évolutif, s’enrichit au fil du temps pour garantir des estimations toujours plus fines et adaptées aux enjeux du recyclage et de la reprise.",
        "DESCRIPTION": "Retrouvez toutes nos sources :",
        "LINK_1": "Référentiel de calcul",
        "LINK_2": "Sources ADEME",
        "LINK_3": "Notes Méthodologique de calculateur",
        "LINK_4": "Notes Méthodologique des ACV"
      },
      "BUTTON": {
        "DOWNLOAD_REPORT": "Télécharger le rapport"
      },
      "MAIN": {
        "REPORT": {
          "WORLD_TOUR_TITLE": "Tours du monde évités",
          "CO2": "CO2 évités",
          "MATERIALS": "Matières premières non extraites"
        },
        "SELECT": {
          "STORE": "Sélectionnez votre magasin",
          "MANUFACTURER": "Sélectionnez la marque"
        },
        "TABLE": {
          "HEADER": {
            "CURRENT_YEAR": "Nb de dossiers (année en cours)",
            "LAST_YEAR": "Année précédente",
            "TWO_YEAR": "Il y a 2 ans",
            "IMPACT_MATERIAL": "Impact matière (kg) (année n-1)",
            "CO2_IMPACT": "Impact CO2 (kg) (année n-1)"
          },
          "REPAIR_ROW": "Réparation",
          "REPAIR_ECOSYSTEM_ROW": "Calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
          "REPAIR_PROXY_ROW": "Étudiés par Proxi ACV Ademe + Autres sources",
          "REPAIR_WITHOUT_ROW": "Sans étude préalable",
          "REUSE_ROW": "Réemploi",
          "REUSE_ECOSYSTEM_ROW": "Calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
          "REUSE_PROXY_ROW": "Étudiés par Proxi ACV Ademe + Autres sources",
          "REUSE_WITHOUT_ROW": "Sans étude préalable",
          "RECYCLED_ROW": "Recyclage",
          "RECYCLED_BY_BOOMERANG_ROW": "Via BOOMERANG",
          "RECYCLED_BY_REPAIRER_ROW": "Autres",
          "RENTAL_ROW": "Location",
          "WITHOUT_INFORMATION_ROW": "Sans information",
          "TOTAL": "Total"
        }
      }
    }
  }
}
